var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("OPERATIONAL")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$$route$query, _vm$$route$query2, _vm$$route$query3, _vm$$route, _vm$$route$query5, _vm$$route$query8, _vm$$route$query9, _vm$$route$query10, _vm$$route$query11, _vm$optionsFleets, _vm$$route$query14, _vm$$route$query15, _vm$$route$query16, _vm$$route$query17, _vm$$route$query18, _vm$$route$query19, _vm$$route$query20, _vm$$route$query21, _vm$$route$query22, _vm$$route$query23, _vm$$route$query24, _vm$$route$query25, _vm$$route$query26, _vm$$route$query27, _vm$$route$query28, _vm$$route$query29, _vm$$route$query30, _vm$$route$query31, _vm$$route$query32, _vm$$route$query33, _vm$$route$query34, _vm$$route$query35, _vm$$route$query36, _vm$$route$query37, _vm$$route$query38, _vm$$route$query39, _vm$$route$query40, _vm$$route$query41, _vm$$route$query42, _vm$$route$query43, _vm$$route$query44, _vm$$route$query45, _vm$$route$query46, _vm$$route$query47, _vm$$route$query48, _vm$$route$query49, _vm$$route$query50, _vm$$route$query51, _vm$$route$query52, _vm$$route$query53, _vm$$route$query54, _vm$$route$query55, _vm$$route$query56, _vm$$route$query57, _vm$$route$query58, _vm$$route$query59, _vm$$route$query60, _vm$$route$query61, _vm$$route$query62, _vm$$route$query63, _vm$$route$query64, _vm$$route$query65, _vm$$route$query66, _vm$$route$query67, _vm$$route$query68, _vm$$route$query69, _vm$$route$query70, _vm$$route$query71, _vm$$route$query72, _vm$$route$query73, _vm$$route$query74, _vm$$route$query75, _vm$$route$query76, _vm$$route$query77, _vm$$route$query78, _vm$$route$query79, _vm$$route$query80, _vm$formOperationalAc, _vm$formOperationalAc2, _vm$$route$query81, _vm$formOperationalAc3, _vm$formOperationalAc4, _vm$$route$query82, _vm$$route$query83, _vm$$route$query84, _vm$$route$query85, _vm$$route$query86, _vm$formOperationalAc5, _vm$$route$query87, _vm$$route$query88, _vm$$route$query89, _vm$$route$query90, _vm$$route$query91, _vm$$route$query92, _vm$$route$query93, _vm$$route$query94, _vm$$route$query95, _vm$$route$query96, _vm$$route$query97, _vm$$route$query98, _vm$$route$query99, _vm$$route$query100, _vm$$route$query101, _vm$$route$query102, _vm$formOperationalAc6, _vm$formOperationalAc7, _vm$formOperationalAc8, _vm$formOperationalAc9, _vm$$route$query103, _vm$$route$query104, _vm$$route2, _vm$$route2$query, _vm$$route3, _vm$$route3$query, _vm$$route$query105, _vm$$route$query116;
        return [_c('b-row', [_c('b-col', {
          ref: "leftContent",
          staticClass: "h-auto",
          staticStyle: {
            "max-height": "max-content"
          },
          attrs: {
            "md": (_vm$$route$query = _vm.$route.query) !== null && _vm$$route$query !== void 0 && _vm$$route$query.preview ? '12' : '8'
          }
        }, [_c('div', {
          staticClass: "d-flex align-items-center justify-content-between w-100"
        }, [_c('h5', {
          staticClass: "card-title text-primary mb-4"
        }, [_c('strong', [_vm._v("INPUT DAILY OPERATIONAL")])]), ((_vm$$route$query2 = _vm.$route.query) === null || _vm$$route$query2 === void 0 ? void 0 : _vm$$route$query2.preview) !== undefined || (_vm$$route$query3 = _vm.$route.query) !== null && _vm$$route$query3 !== void 0 && _vm$$route$query3.preview ? _c('b-button', {
          attrs: {
            "type": "submit",
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              var _vm$$route$query4;
              return _vm.toEditHistory((_vm$$route$query4 = _vm.$route.query) === null || _vm$$route$query4 === void 0 ? void 0 : _vm$$route$query4.activityEditId);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pen"
        }), _vm._v(" " + _vm._s((_vm$$route = _vm.$route) !== null && _vm$$route !== void 0 && (_vm$$route$query5 = _vm$$route.query) !== null && _vm$$route$query5 !== void 0 && _vm$$route$query5.preview ? 'Edit' : 'Preview'))]) : _vm._e()], 1), _c('hr'), _c('b-row', [_c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "First Fleet *",
            "label-for": "first_fleet"
          }
        }, [_c('h5', [_c('strong', [_vm._v(_vm._s(!_vm.isEdit ? _vm.fleet.name : _vm.fleetEdit.name))])])])], 1), !_vm.loadingOperational ? [_c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_vm.formOperationalActivity.activityType ? _c('b-form-group', {
          attrs: {
            "label": "Activity Type",
            "label-for": "activityType"
          }
        }, [_vm._l(_vm.activityTypeOpt, function (item, index) {
          var _vm$$route$query6, _vm$$route$query7;
          return [_c('b-form-radio', {
            key: index,
            attrs: {
              "inline": "",
              "name": item.name,
              "value": item.value,
              "disabled": _vm.loadingCheck || _vm.locked || ((_vm$$route$query6 = _vm.$route.query) === null || _vm$$route$query6 === void 0 ? void 0 : _vm$$route$query6.preview) || ((_vm$$route$query7 = _vm.$route.query) === null || _vm$$route$query7 === void 0 ? void 0 : _vm$$route$query7.activityEditId)
            },
            model: {
              value: _vm.formOperationalActivity.activityType,
              callback: function callback($$v) {
                _vm.$set(_vm.formOperationalActivity, "activityType", $$v);
              },
              expression: "formOperationalActivity.activityType"
            }
          }, [_vm._v(_vm._s(item.label))])];
        })], 2) : _vm._e()], 1), _c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [_vm.formOperationalActivity.activityType === 'trip' ? _c('b-form-group', {
          attrs: {
            "label-for": "new_trip",
            "label": "New Trip"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "checkbox": "",
            "switch": "",
            "value": true,
            "unchecked-value": false,
            "disabled": _vm.locked || _vm.unfinishedTrip.length > 0 && _vm.unfinishedTrip.every(function (el) {
              return el.checked;
            }) || ((_vm$$route$query8 = _vm.$route.query) === null || _vm$$route$query8 === void 0 ? void 0 : _vm$$route$query8.preview) || ((_vm$$route$query9 = _vm.$route.query) === null || _vm$$route$query9 === void 0 ? void 0 : _vm$$route$query9.activityEditId)
          },
          on: {
            "input": function input(val) {
              if (val) {
                if (!_vm.locked) _vm.formOperationalActivity.voyageActivityType = 'UNTOWING';
                _vm.formOperationalActivity.isCrossTrip = false;
              }
            }
          },
          model: {
            value: _vm.formOperationalActivity.newTrip,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "newTrip", $$v);
            },
            expression: "formOperationalActivity.newTrip"
          }
        }, [_vm._v(" Yes / No ")])], 1) : _vm._e()], 1), _c('b-col', {
          attrs: {
            "md": "3"
          }
        }, [!_vm.formOperationalActivity.newTrip && _vm.formOperationalActivity.activityType === 'trip' ? _c('b-form-group', {
          attrs: {
            "label-for": "crossTrip",
            "label": "Cross Trip?"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "switch": "",
            "value": true,
            "unchecked-value": false,
            "disabled": _vm.locked || ((_vm$$route$query10 = _vm.$route.query) === null || _vm$$route$query10 === void 0 ? void 0 : _vm$$route$query10.preview)
          },
          model: {
            value: _vm.formOperationalActivity.isCrossTrip,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "isCrossTrip", $$v);
            },
            expression: "formOperationalActivity.isCrossTrip"
          }
        }, [_vm._v(" Yes / No ")])], 1) : _vm._e()], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('hr'), !((_vm$$route$query11 = _vm.$route.query) !== null && _vm$$route$query11 !== void 0 && _vm$$route$query11.activityEditId) && _vm.formOperationalActivity.activityType === 'trip' ? _c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [!_vm.formOperationalActivity.isCrossTrip && !_vm.formOperationalActivity.newTrip && _vm.unfinishedTrip.length ? _c('div', {
          staticClass: "d-flex flex-column mb-2"
        }, [_c('div', {
          staticClass: "d-flex align-items-start justify-content-start w-100"
        }, [_c('h6', {
          staticClass: "card-title text-primary mb-2"
        }, [_c('strong', [_vm._v("UNFINISHED TRIP ")])])]), _c('div', {
          staticClass: "d-flex overflow-auto border"
        }, [_vm.unfinishedTrip.length > 0 ? _c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("#")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Start Date")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("End Date")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Sub Project")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Fleet")]), _c('th', {
          staticClass: "text-center",
          attrs: {
            "colspan": "12"
          }
        }, [_vm._v("Port of Loading")]), _c('th', {
          staticClass: "text-center bg-warning",
          attrs: {
            "colspan": "12"
          }
        }, [_vm._v("Port of Discharge")])]), _c('tr', [_c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("POL")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Agent POL")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Draught Survey")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Anchor Up")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("In Position / Berthing")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Commenced")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Completed")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Second Berthing")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Cast Out")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("LHV")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Document on Board")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Departure to POD")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("POD")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Agent POD")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Draught Survey")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Arival Time POD")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Anchor Up")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("In Position / Berthing")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Commenced")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Completed")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Second Berthing")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Cast Out")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Departure to POL")])])]), _c('tbody', _vm._l(_vm.unfinishedTrip, function (state, index) {
          var _vm$$route$query12, _state$subProject, _state$subProject$pro, _state$subProject2, _state$portLoading, _Number, _state$portDischarge, _Number2;
          return _c('tr', {
            key: index
          }, [_c('td', [_c('b-form-checkbox', {
            attrs: {
              "disabled": _vm.locked || ((_vm$$route$query12 = _vm.$route.query) === null || _vm$$route$query12 === void 0 ? void 0 : _vm$$route$query12.preview)
            },
            on: {
              "change": function change($event) {
                return _vm.onCheckedUnfinishedTrip(index);
              }
            },
            model: {
              value: state.checked,
              callback: function callback($$v) {
                _vm.$set(state, "checked", $$v);
              },
              expression: "state.checked"
            }
          })], 1), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.startDate ? _vm.moment(state === null || state === void 0 ? void 0 : state.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.endDate ? _vm.moment(state === null || state === void 0 ? void 0 : state.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : (_state$subProject = state.subProject) === null || _state$subProject === void 0 ? void 0 : (_state$subProject$pro = _state$subProject.project) === null || _state$subProject$pro === void 0 ? void 0 : _state$subProject$pro.projectName) + " - " + _vm._s(state === null || state === void 0 ? void 0 : (_state$subProject2 = state.subProject) === null || _state$subProject2 === void 0 ? void 0 : _state$subProject2.name) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_c('div', {
            staticClass: "d-flex"
          }, _vm._l(state === null || state === void 0 ? void 0 : state.vehicle, function (fleet, i) {
            var _state$vehicle;
            return _c('div', {
              key: i,
              staticClass: "d-flex align-items-center"
            }, [_c('b-badge', {
              attrs: {
                "variant": "success"
              }
            }, [_vm._v(_vm._s(fleet === null || fleet === void 0 ? void 0 : fleet.name))]), i == 0 && (state === null || state === void 0 ? void 0 : (_state$vehicle = state.vehicle) === null || _state$vehicle === void 0 ? void 0 : _state$vehicle.length) > 1 ? _c('LinkIcon', {
              staticClass: "mx-2"
            }) : _vm._e()], 1);
          }), 0)]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s((state === null || state === void 0 ? void 0 : (_state$portLoading = state.portLoading) === null || _state$portLoading === void 0 ? void 0 : _state$portLoading.portName) || (state === null || state === void 0 ? void 0 : state.portLoadingOther)) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.agentPol))]), _c('td', {
            staticClass: "text-truncate text-center"
          }, [_vm._v(_vm._s(((_Number = Number(state === null || state === void 0 ? void 0 : state.polDraughtSurvey)) === null || _Number === void 0 ? void 0 : _Number.toLocaleString()) || 0))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polAnchorUp ? _vm.moment(state === null || state === void 0 ? void 0 : state.polAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polBerthing ? _vm.moment(state === null || state === void 0 ? void 0 : state.polBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polCommenced ? _vm.moment(state === null || state === void 0 ? void 0 : state.polCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polCompleted ? _vm.moment(state === null || state === void 0 ? void 0 : state.polCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polCastIn ? _vm.moment(state === null || state === void 0 ? void 0 : state.polCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polCastOut ? _vm.moment(state === null || state === void 0 ? void 0 : state.polCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polLhv ? _vm.moment(state === null || state === void 0 ? void 0 : state.polLhv, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polDocOnBoard ? _vm.moment(state === null || state === void 0 ? void 0 : state.polDocOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polDeparture ? _vm.moment(state === null || state === void 0 ? void 0 : state.polDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s((state === null || state === void 0 ? void 0 : (_state$portDischarge = state.portDischarge) === null || _state$portDischarge === void 0 ? void 0 : _state$portDischarge.portName) || (state === null || state === void 0 ? void 0 : state.portDischargeOther)) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.agentPod))]), _c('td', {
            staticClass: "text-truncate text-center"
          }, [_vm._v(_vm._s(((_Number2 = Number(state === null || state === void 0 ? void 0 : state.podDraughtSurvey)) === null || _Number2 === void 0 ? void 0 : _Number2.toLocaleString()) || 0))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podArrivalTime ? _vm.moment(state === null || state === void 0 ? void 0 : state.podArrivalTime, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podAnchorUp ? _vm.moment(state === null || state === void 0 ? void 0 : state.podAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podBerthing ? _vm.moment(state === null || state === void 0 ? void 0 : state.podBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podCommenced ? _vm.moment(state === null || state === void 0 ? void 0 : state.podCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podCompleted ? _vm.moment(state === null || state === void 0 ? void 0 : state.podCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podCastIn ? _vm.moment(state === null || state === void 0 ? void 0 : state.podCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podCastOut ? _vm.moment(state === null || state === void 0 ? void 0 : state.podCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podDeparture ? _vm.moment(state === null || state === void 0 ? void 0 : state.podDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")])]);
        }), 0)]) : _c('strong', {
          staticClass: "text-center text-muted"
        }, [!_vm.formOperationalActivity.isCrossTrip ? _c('span', [_vm._v("No Data Found.")]) : _vm._e()])])]) : _vm._e()]), _vm.formOperationalActivity.isCrossTrip && !_vm.formOperationalActivity.newTrip ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Fleet",
            "label-for": "fleet"
          }
        }, [_c('v-select', {
          attrs: {
            "label": "text",
            "options": (_vm$optionsFleets = _vm.optionsFleets) === null || _vm$optionsFleets === void 0 ? void 0 : _vm$optionsFleets.filter(function (el) {
              var _vm$$route$query13;
              return el.value != ((_vm$$route$query13 = _vm.$route.query) === null || _vm$$route$query13 === void 0 ? void 0 : _vm$$route$query13.vehicleId);
            }),
            "reduce": function reduce(optionsFleets) {
              return optionsFleets.value;
            },
            "placeholder": "Select...",
            "disabled": ((_vm$$route$query14 = _vm.$route.query) === null || _vm$$route$query14 === void 0 ? void 0 : _vm$$route$query14.preview) || _vm.locked
          },
          on: {
            "input": _vm.onChangeFleet
          },
          model: {
            value: _vm.formOperationalActivity.fleetId,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "fleetId", $$v);
            },
            expression: "formOperationalActivity.fleetId"
          }
        })], 1)], 1) : _vm._e(), _vm.formOperationalActivity.isCrossTrip && !_vm.formOperationalActivity.newTrip ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "d-flex flex-column mb-2"
        }, [_c('h6', {
          staticClass: "card-title text-primary mb-2"
        }, [_c('strong', [_vm._v("UNFINISHED TRIP (Cross Trip)")])]), !_vm.formOperationalActivity.fleetId ? _c('strong', {
          staticClass: "text-muted"
        }, [_vm._v("Select Vehicle.")]) : _vm._e(), _vm.crossTripList.length > 0 ? _c('div', {
          staticClass: "d-flex overflow-auto border"
        }, [_c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("#")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Start Date")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("End Date")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Sub Project")]), _c('th', {
          staticClass: "text-truncate align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Fleet")]), _c('th', {
          staticClass: "text-center",
          attrs: {
            "colspan": "12"
          }
        }, [_vm._v("Port of Loading")]), _c('th', {
          staticClass: "text-center bg-warning",
          attrs: {
            "colspan": "12"
          }
        }, [_vm._v("Port of Discharge")])]), _c('tr', [_c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("POL")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Agent POL")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Draught Survey")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Anchor Up")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("In Position / Berthing")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Commenced")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Completed")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Second Berthing")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Cast Out")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("LHV")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Document on Board")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Departure to POD")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("POD")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Agent POD")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Draught Survey")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Arival Time POD")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Anchor Up")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("In Position / Berthing")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Commenced")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Completed")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Second Berthing")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Cast Out")]), _c('th', {
          staticClass: "text-truncate bg-warning"
        }, [_vm._v("Departure to POL")])])]), _c('tbody', _vm._l(_vm.crossTripList, function (state, index) {
          var _state$subProject3, _state$subProject3$pr, _state$subProject4, _state$portLoading2, _state$portDischarge2;
          return _c('tr', {
            key: index
          }, [_c('td', [_c('b-form-checkbox', {
            attrs: {
              "disabled": _vm.locked
            },
            on: {
              "change": function change($event) {
                return _vm.onCheckedCrossTrip(state, index);
              }
            },
            model: {
              value: state.checked,
              callback: function callback($$v) {
                _vm.$set(state, "checked", $$v);
              },
              expression: "state.checked"
            }
          })], 1), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.startDate ? _vm.moment(state === null || state === void 0 ? void 0 : state.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.endDate ? _vm.moment(state === null || state === void 0 ? void 0 : state.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : (_state$subProject3 = state.subProject) === null || _state$subProject3 === void 0 ? void 0 : (_state$subProject3$pr = _state$subProject3.project) === null || _state$subProject3$pr === void 0 ? void 0 : _state$subProject3$pr.projectName) + " - " + _vm._s(state === null || state === void 0 ? void 0 : (_state$subProject4 = state.subProject) === null || _state$subProject4 === void 0 ? void 0 : _state$subProject4.name) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_c('div', {
            staticClass: "d-flex"
          }, _vm._l(state === null || state === void 0 ? void 0 : state.vehicle, function (fleet, i) {
            var _state$vehicle2;
            return _c('div', {
              key: i,
              staticClass: "d-flex align-items-center"
            }, [_c('b-badge', {
              attrs: {
                "variant": "success"
              }
            }, [_vm._v(_vm._s(fleet === null || fleet === void 0 ? void 0 : fleet.name))]), i == 0 && (state === null || state === void 0 ? void 0 : (_state$vehicle2 = state.vehicle) === null || _state$vehicle2 === void 0 ? void 0 : _state$vehicle2.length) > 1 ? _c('LinkIcon', {
              staticClass: "mx-2"
            }) : _vm._e()], 1);
          }), 0)]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s((state === null || state === void 0 ? void 0 : (_state$portLoading2 = state.portLoading) === null || _state$portLoading2 === void 0 ? void 0 : _state$portLoading2.portName) || (state === null || state === void 0 ? void 0 : state.portLoadingOther)) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.agentPol))]), _c('td', {
            staticClass: "text-truncate text-center"
          }, [_vm._v(_vm._s(Number(state === null || state === void 0 ? void 0 : state.polDraughtSurvey).toLocaleString() || 0))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polAnchorUp ? _vm.moment(state === null || state === void 0 ? void 0 : state.polAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polBerthing ? _vm.moment(state === null || state === void 0 ? void 0 : state.polBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polCommenced ? _vm.moment(state === null || state === void 0 ? void 0 : state.polCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polCompleted ? _vm.moment(state === null || state === void 0 ? void 0 : state.polCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polCastIn ? _vm.moment(state === null || state === void 0 ? void 0 : state.polCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polCastOut ? _vm.moment(state === null || state === void 0 ? void 0 : state.polCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polLhv ? _vm.moment(state === null || state === void 0 ? void 0 : state.polLhv, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polDocOnBoard ? _vm.moment(state === null || state === void 0 ? void 0 : state.polDocOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.polDeparture ? _vm.moment(state === null || state === void 0 ? void 0 : state.polDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s((state === null || state === void 0 ? void 0 : (_state$portDischarge2 = state.portDischarge) === null || _state$portDischarge2 === void 0 ? void 0 : _state$portDischarge2.portName) || (state === null || state === void 0 ? void 0 : state.portDischargeOther)) + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : state.agentPod))]), _c('td', {
            staticClass: "text-truncate text-center"
          }, [_vm._v(_vm._s(Number(state === null || state === void 0 ? void 0 : state.podDraughtSurvey).toLocaleString() || 0))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podArrivalTime ? _vm.moment(state === null || state === void 0 ? void 0 : state.podArrivalTime, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podAnchorUp ? _vm.moment(state === null || state === void 0 ? void 0 : state.podAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podBerthing ? _vm.moment(state === null || state === void 0 ? void 0 : state.podBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podCommenced ? _vm.moment(state === null || state === void 0 ? void 0 : state.podCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podCompleted ? _vm.moment(state === null || state === void 0 ? void 0 : state.podCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podCastIn ? _vm.moment(state === null || state === void 0 ? void 0 : state.podCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podCastOut ? _vm.moment(state === null || state === void 0 ? void 0 : state.podCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.podDeparture ? _vm.moment(state === null || state === void 0 ? void 0 : state.podDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " ")])]);
        }), 0)])]) : _vm._e(), _vm.crossTripList.length <= 0 && _vm.formOperationalActivity.fleetId ? _c('strong', {
          staticClass: "text-center text-muted"
        }, [_vm._v("No Data found.")]) : _vm._e()])]) : _vm._e()], 1) : _vm._e(), _vm.formOperationalActivity.newTrip || _vm.isUnfinishedTripChecked || _vm.isCrossTripChecked || _vm.isEdit || _vm.$route.query.activityEditId || _vm.formOperationalActivity.activityType === 'non trip' ? [_vm.showVoyageWidth ? _c('b-form-group', {
          attrs: {
            "label": "Voyage with",
            "label-for": "voyage_with"
          }
        }, [_c('b-form-radio', {
          staticClass: "custom-radio-color-checked",
          attrs: {
            "inline": "",
            "color": "default",
            "name": "color",
            "value": "UNTOWING",
            "disabled": _vm.loadingCheck || _vm.locked && !_vm.isEdit || ((_vm$$route$query15 = _vm.$route.query) === null || _vm$$route$query15 === void 0 ? void 0 : _vm$$route$query15.preview)
          },
          model: {
            value: _vm.formOperationalActivity.voyageActivityType,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "voyageActivityType", $$v);
            },
            expression: "formOperationalActivity.voyageActivityType"
          }
        }, [_vm._v("Towing Free")]), _c('b-form-radio', {
          staticClass: "custom-radio-color-checked",
          attrs: {
            "inline": "",
            "color": "primary",
            "name": "color",
            "value": "SINGLE_TOWING",
            "disabled": _vm.loadingCheck || _vm.locked && !_vm.isEdit || ((_vm$$route$query16 = _vm.$route.query) === null || _vm$$route$query16 === void 0 ? void 0 : _vm$$route$query16.preview)
          },
          model: {
            value: _vm.formOperationalActivity.voyageActivityType,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "voyageActivityType", $$v);
            },
            expression: "formOperationalActivity.voyageActivityType"
          }
        }, [_vm._v("Single Towing")]), _c('b-form-radio', {
          staticClass: "custom-radio-color-checked",
          attrs: {
            "inline": "",
            "color": "primary",
            "name": "color",
            "value": "DOUBLE_TOWING",
            "disabled": _vm.loadingCheck || _vm.locked && !_vm.isEdit || ((_vm$$route$query17 = _vm.$route.query) === null || _vm$$route$query17 === void 0 ? void 0 : _vm$$route$query17.preview)
          },
          model: {
            value: _vm.formOperationalActivity.voyageActivityType,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "voyageActivityType", $$v);
            },
            expression: "formOperationalActivity.voyageActivityType"
          }
        }, [_vm._v("Double Towing")])], 1) : _vm._e(), _c('b-row', [_vm.formOperationalActivity.voyageActivityType === 'SINGLE_TOWING' || _vm.formOperationalActivity.voyageActivityType === 'DOUBLE_TOWING' ? _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-row', {
          staticClass: "mb-3"
        }, [_c('b-col', {
          attrs: {
            "md": "7"
          }
        }, [_c('label', {
          attrs: {
            "for": "second_fleet"
          }
        }, [_vm._v("Second Fleet *")])]), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "md": "5"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "name": "check-button",
            "switch": "",
            "inline": "",
            "disabled": _vm.loadingCheck || _vm.locked && !_vm.isEdit || ((_vm$$route$query18 = _vm.$route.query) === null || _vm$$route$query18 === void 0 ? void 0 : _vm$$route$query18.preview)
          },
          model: {
            value: _vm.formOperationalActivity.vehicles[0].breakdown,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity.vehicles[0], "breakdown", $$v);
            },
            expression: "formOperationalActivity.vehicles[0].breakdown"
          }
        }, [_vm._v(" Breakdown ? ")])], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('v-select', {
          attrs: {
            "label": "name",
            "required": "",
            "placeholder": "Select...",
            "options": _vm.fleetListFiltered,
            "reduce": function reduce(fleetList) {
              return fleetList.id;
            },
            "disabled": _vm.locked && !_vm.isEdit || _vm.loadingCheck || ((_vm$$route$query19 = _vm.$route.query) === null || _vm$$route$query19 === void 0 ? void 0 : _vm$$route$query19.preview)
          },
          on: {
            "input": function input($event) {
              return _vm.handleSelectFleet(_vm.fleetList, $event, 0);
            }
          },
          model: {
            value: _vm.formOperationalActivity.vehicles[0].vehicleId,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity.vehicles[0], "vehicleId", $$v);
            },
            expression: "formOperationalActivity.vehicles[0].vehicleId"
          }
        })], 1)], 1)], 1) : _vm._e(), _vm.formOperationalActivity.voyageActivityType === 'DOUBLE_TOWING' ? _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-row', {
          staticClass: "mb-3"
        }, [_c('b-col', {
          attrs: {
            "md": "7"
          }
        }, [_c('label', {
          attrs: {
            "for": "another_fleet"
          }
        }, [_vm._v("Another Fleet *")])]), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "md": "5"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "name": "check-button",
            "switch": "",
            "inline": "",
            "disabled": _vm.loadingCheck || _vm.locked && !_vm.isEdit || ((_vm$$route$query20 = _vm.$route.query) === null || _vm$$route$query20 === void 0 ? void 0 : _vm$$route$query20.preview)
          },
          model: {
            value: _vm.formOperationalActivity.vehicles[1].breakdown,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity.vehicles[1], "breakdown", $$v);
            },
            expression: "formOperationalActivity.vehicles[1].breakdown"
          }
        }, [_vm._v(" Breakdown ? ")])], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('v-select', {
          attrs: {
            "label": "name",
            "options": _vm.fleetListFiltered,
            "reduce": function reduce(fleetList) {
              return fleetList.id;
            },
            "disabled": _vm.loadingCheck || _vm.locked && !_vm.isEdit || ((_vm$$route$query21 = _vm.$route.query) === null || _vm$$route$query21 === void 0 ? void 0 : _vm$$route$query21.preview)
          },
          on: {
            "input": function input($event) {
              return _vm.handleSelectFleet(_vm.fleetList, $event, 1);
            }
          },
          model: {
            value: _vm.formOperationalActivity.vehicles[1].vehicleId,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity.vehicles[1], "vehicleId", $$v);
            },
            expression: "formOperationalActivity.vehicles[1].vehicleId"
          }
        })], 1)], 1)], 1) : _vm._e()], 1), _c('hr')] : _vm._e()], 2), _vm.formOperationalActivity.newTrip || _vm.isUnfinishedTripChecked || _vm.isCrossTripChecked || _vm.isEdit || _vm.formOperationalActivity.activityType === 'non trip' ? [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Start Date Activity *",
            "label-for": "start_date"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          class: {
            'border-danger': _vm.$v.formOperationalActivity.startDate.$error
          },
          attrs: {
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date and time",
            "format": "DD-MM-YYYY HH:mm",
            "disabled": _vm.locked && !_vm.isEdit || _vm.loadingCheck || ((_vm$$route$query22 = _vm.$route.query) === null || _vm$$route$query22 === void 0 ? void 0 : _vm$$route$query22.preview)
          },
          model: {
            value: _vm.formOperationalActivity.startDate,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "startDate", $$v);
            },
            expression: "formOperationalActivity.startDate"
          }
        }), _c('p', [_vm.$v.formOperationalActivity.startDate.$error && !_vm.$v.formOperationalActivity.startDate.required ? _c('small', {
          staticClass: "text-danger m-t-5"
        }, [_vm._v("Start Date is Required")]) : _vm._e()])], 1)], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "End Date Activity *",
            "label-for": "end_date"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          class: {
            'border-danger': _vm.$v.formOperationalActivity.startDate.$error
          },
          attrs: {
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date and time",
            "format": "DD-MM-YYYY HH:mm",
            "disabled": _vm.locked && !_vm.isEdit || _vm.loadingCheck || ((_vm$$route$query23 = _vm.$route.query) === null || _vm$$route$query23 === void 0 ? void 0 : _vm$$route$query23.preview)
          },
          model: {
            value: _vm.formOperationalActivity.endDate,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "endDate", $$v);
            },
            expression: "formOperationalActivity.endDate"
          }
        }), _c('p', [_vm.$v.formOperationalActivity.endDate.$error && !_vm.$v.formOperationalActivity.endDate.required ? _c('small', {
          staticClass: "text-danger m-t-5"
        }, [_vm._v("End Date is Required")]) : _vm._e()])], 1)], 1), !_vm.isEdit || !((_vm$$route$query24 = _vm.$route.query) !== null && _vm$$route$query24 !== void 0 && _vm$$route$query24.preview) ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "",
            "label-for": "process"
          }
        }, [!_vm.loadingCheck ? _c('b-button', {
          staticClass: "mt-3",
          attrs: {
            "block": "",
            "variant": "success",
            "disabled": _vm.locked || _vm.$route.query.activityEditId
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.checkVoyage.apply(null, arguments);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-map-pin"
        }), _vm._v("Process")]) : _c('b-button', {
          staticClass: "mt-3",
          attrs: {
            "block": "",
            "variant": "light"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.edit.apply(null, arguments);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v("Edit")]), _vm.nextStep || _vm.locked ? _c('b-button', {
          staticClass: "mt-3",
          attrs: {
            "block": "",
            "variant": "danger",
            "type": "button"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.resetForm.apply(null, arguments);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-ban"
        }), _vm._v("Reset Form")]) : _vm._e()], 1)], 1) : _vm._e()] : _vm._e()] : _vm._e()], 2), _c('hr'), _vm.nextStep && !_vm.loadingOperational && !_vm.isActivityId || _vm.isActivityId && !_vm.loadingOperational ? [_c('b-col', {
          staticClass: "my-4",
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "d-flex align-items-center justify-content-end w-100"
        }, [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.saveDraft
          }
        }, [_c('i', {
          staticClass: "fa fa-save"
        }), _vm._v("Save Draft")]), _c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": _vm.pasteDraft
          }
        }, [_c('i', {
          staticClass: "fa fa-clipboard"
        }), _vm._v("Paste Draft")])], 1)]), _vm.formOperationalActivity.activityType === 'trip' ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("PROJECT RECORD")])]), _c('b-form', [_c('b-form-group', {
          attrs: {
            "label": "Project *",
            "label-for": "project"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "options": _vm.projectOptions,
            "reduce": function reduce(option) {
              return option.value;
            },
            "placeholder": "Select one",
            "track-by": "value",
            "label": "text",
            "disabled": (_vm$$route$query25 = _vm.$route.query) === null || _vm$$route$query25 === void 0 ? void 0 : _vm$$route$query25.preview,
            "required": ""
          },
          on: {
            "input": _vm.handleChangeProject
          },
          model: {
            value: _vm.formOperationalActivity.subProjectId,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "subProjectId", $$v);
            },
            expression: "formOperationalActivity.subProjectId"
          }
        })], 1)], 1)], 1)]), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('hr')]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("LOADING ACTIVITY RECORD")])]), _c('b-form-row', [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Port of Loading",
            "label-for": "port_of_loading"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query26 = _vm.$route.query) === null || _vm$$route$query26 === void 0 ? void 0 : _vm$$route$query26.preview,
            "label": "text",
            "options": _vm.positionListPOL,
            "reduce": function reduce(positionListPOL) {
              return positionListPOL.value;
            },
            "placeholder": "Select..."
          },
          on: {
            "input": _vm.handleOriginChange
          },
          model: {
            value: _vm.formOperationalActivity.portLoading,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "portLoading", $$v);
            },
            expression: "formOperationalActivity.portLoading"
          }
        })], 1)], 1), ['Other'].includes(_vm.formOperationalActivity.portLoading) ? _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Other POL",
            "label-for": "POL"
          }
        }, [_c('b-form-input', {
          staticClass: "bg-white",
          attrs: {
            "type": "text",
            "disabled": (_vm$$route$query27 = _vm.$route.query) === null || _vm$$route$query27 === void 0 ? void 0 : _vm$$route$query27.preview
          },
          on: {
            "blur": function blur() {
              return _vm.formOperationalActivity.originOther = _vm.formOperationalActivity.portLoadingOther;
            }
          },
          model: {
            value: _vm.formOperationalActivity.portLoadingOther,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "portLoadingOther", $$v);
            },
            expression: "formOperationalActivity.portLoadingOther"
          }
        })], 1)], 1) : _vm._e(), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate",
          attrs: {
            "label": "Agent POL",
            "label-for": "agent_pol"
          }
        }, [_c('b-form-input', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query28 = _vm.$route.query) === null || _vm$$route$query28 === void 0 ? void 0 : _vm$$route$query28.preview,
            "type": "text",
            "id": "agent_pol",
            "placeholder": "Type Text"
          },
          on: {
            "change": function change() {
              _vm.formOperationalActivity.agentPod = _vm.formOperationalActivity.agentPol;
            }
          },
          model: {
            value: _vm.formOperationalActivity.agentPol,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "agentPol", $$v);
            },
            expression: "formOperationalActivity.agentPol"
          }
        })], 1)], 1), ['Other'].includes(_vm.formOperationalActivity.portLoading) ? _c('b-col', {
          attrs: {
            "md": "6"
          }
        }) : _vm._e(), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Is Pol Sts Mv:",
            "label-for": "kind-fleet"
          }
        }, [_c('b-form-checkbox', {
          key: _vm.index,
          attrs: {
            "disabled": (_vm$$route$query29 = _vm.$route.query) === null || _vm$$route$query29 === void 0 ? void 0 : _vm$$route$query29.preview,
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          model: {
            value: _vm.formOperationalActivity.polStsMv,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polStsMv", $$v);
            },
            expression: "formOperationalActivity.polStsMv"
          }
        }, [_vm._v(" No / Yes ")])], 1)], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_vm.formOperationalActivity.polStsMv ? _c('b-form-group', {
          staticClass: "text-truncate",
          attrs: {
            "label": "Pol Mv Name",
            "label-for": "pol_mv_name"
          }
        }, [_c('b-form-input', {
          class: {
            'bg-white': _vm.formOperationalActivity.polStsMv
          },
          attrs: {
            "type": "text",
            "id": "pol_mv_name",
            "placeholder": "Type Text",
            "disabled": !_vm.formOperationalActivity.polStsMv || ((_vm$$route$query30 = _vm.$route.query) === null || _vm$$route$query30 === void 0 ? void 0 : _vm$$route$query30.preview)
          },
          model: {
            value: _vm.formOperationalActivity.polMvName,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polMvName", $$v);
            },
            expression: "formOperationalActivity.polMvName"
          }
        })], 1) : _vm._e()], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Pol grab Type",
            "label-for": "pod_grab_type"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query31 = _vm.$route.query) === null || _vm$$route$query31 === void 0 ? void 0 : _vm$$route$query31.preview,
            "label": "text",
            "options": _vm.polGrabTypeOpt,
            "reduce": function reduce(item) {
              return item.value;
            },
            "placeholder": "Select Pol Grab Type"
          },
          model: {
            value: _vm.formOperationalActivity.polGrabType,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polGrabType", $$v);
            },
            expression: "formOperationalActivity.polGrabType"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_vm.formOperationalActivity.polGrabType == 'gearless' ? _c('b-form-group', {
          staticClass: "text-truncate",
          attrs: {
            "label": "Pol Fc Name",
            "label-for": "pol_fc_name"
          }
        }, [_c('b-form-input', {
          class: {
            'bg-white': _vm.formOperationalActivity.polGrabType == 'gearless'
          },
          attrs: {
            "disabled": _vm.formOperationalActivity.polGrabType !== 'gearless' || ((_vm$$route$query32 = _vm.$route.query) === null || _vm$$route$query32 === void 0 ? void 0 : _vm$$route$query32.preview),
            "type": "text",
            "id": "pol_mv_name",
            "placeholder": "Type Text"
          },
          model: {
            value: _vm.formOperationalActivity.polFcName,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polFcName", $$v);
            },
            expression: "formOperationalActivity.polFcName"
          }
        })], 1) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "NOR",
            "label-for": "nor"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query33 = _vm.$route.query) === null || _vm$$route$query33 === void 0 ? void 0 : _vm$$route$query33.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          model: {
            value: _vm.formOperationalActivity.polNor,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polNor", $$v);
            },
            expression: "formOperationalActivity.polNor"
          }
        })], 1)], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "NOA",
            "label-for": "noa"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query34 = _vm.$route.query) === null || _vm$$route$query34 === void 0 ? void 0 : _vm$$route$query34.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          model: {
            value: _vm.formOperationalActivity.polNoa,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polNoa", $$v);
            },
            expression: "formOperationalActivity.polNoa"
          }
        })], 1)], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Anchor Up",
            "label-for": "polAnchorUp"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query35 = _vm.$route.query) === null || _vm$$route$query35 === void 0 ? void 0 : _vm$$route$query35.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.polArrivalTime, _vm.formOperationalActivity.polAnchorUp, 'Anchor Up', 'Arrival Time', 1);
            }
          },
          model: {
            value: _vm.formOperationalActivity.polAnchorUp,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polAnchorUp", $$v);
            },
            expression: "formOperationalActivity.polAnchorUp"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 1 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "In Position / Berthing",
            "label-for": "polBerthing"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query36 = _vm.$route.query) === null || _vm$$route$query36 === void 0 ? void 0 : _vm$$route$query36.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.polAnchorUp, _vm.formOperationalActivity.polBerthing, 'Berthing', 'Anchor Up', 2);
            }
          },
          model: {
            value: _vm.formOperationalActivity.polBerthing,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polBerthing", $$v);
            },
            expression: "formOperationalActivity.polBerthing"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 2 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Commenced",
            "label-for": "polCommenced"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query37 = _vm.$route.query) === null || _vm$$route$query37 === void 0 ? void 0 : _vm$$route$query37.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.polBerthing, _vm.formOperationalActivity.polCommenced, 'Commenced', 'Berthing', 3);
            }
          },
          model: {
            value: _vm.formOperationalActivity.polCommenced,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polCommenced", $$v);
            },
            expression: "formOperationalActivity.polCommenced"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 3 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Completed",
            "label-for": "completed"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query38 = _vm.$route.query) === null || _vm$$route$query38 === void 0 ? void 0 : _vm$$route$query38.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.polCommenced, _vm.formOperationalActivity.polCompleted, 'Completed', 'Commenced', 4);
            }
          },
          model: {
            value: _vm.formOperationalActivity.polCompleted,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polCompleted", $$v);
            },
            expression: "formOperationalActivity.polCompleted"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 4 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Draught Survey",
            "label-for": "polDraughtSurvey"
          }
        }, [_c('InputCurrency', {
          attrs: {
            "prepend": "",
            "disabled": (_vm$$route$query39 = _vm.$route.query) === null || _vm$$route$query39 === void 0 ? void 0 : _vm$$route$query39.preview,
            "placeholder": "Type Number"
          },
          on: {
            "input": function input($event) {
              _vm.formOperationalActivity.cargoLoading = _vm.formOperationalActivity.polDraughtSurvey;
            }
          },
          model: {
            value: _vm.formOperationalActivity.polDraughtSurvey,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polDraughtSurvey", $$v);
            },
            expression: "formOperationalActivity.polDraughtSurvey"
          }
        })], 1)], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "BL Date",
            "label-for": "blDate"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query40 = _vm.$route.query) === null || _vm$$route$query40 === void 0 ? void 0 : _vm$$route$query40.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          model: {
            value: _vm.formOperationalActivity.polBlDate,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polBlDate", $$v);
            },
            expression: "formOperationalActivity.polBlDate"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 5 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Second Berthing",
            "label-for": "polCastIn"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query41 = _vm.$route.query) === null || _vm$$route$query41 === void 0 ? void 0 : _vm$$route$query41.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          model: {
            value: _vm.formOperationalActivity.polCastIn,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polCastIn", $$v);
            },
            expression: "formOperationalActivity.polCastIn"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 5 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Cast out",
            "label-for": "polCastOut"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query42 = _vm.$route.query) === null || _vm$$route$query42 === void 0 ? void 0 : _vm$$route$query42.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.polCompleted, _vm.formOperationalActivity.polCastOut, 'Cast Out', 'Completed', 5);
            }
          },
          model: {
            value: _vm.formOperationalActivity.polCastOut,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polCastOut", $$v);
            },
            expression: "formOperationalActivity.polCastOut"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 5 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "LHV",
            "label-for": "polLhv"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query43 = _vm.$route.query) === null || _vm$$route$query43 === void 0 ? void 0 : _vm$$route$query43.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.polCastOut, _vm.formOperationalActivity.polLhv, 'LHV', 'Cast Out', 6);
            }
          },
          model: {
            value: _vm.formOperationalActivity.polLhv,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polLhv", $$v);
            },
            expression: "formOperationalActivity.polLhv"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 6 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _vm.showDocumentOnBoard ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Document On Board POL",
            "label-for": "document_on_board"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query44 = _vm.$route.query) === null || _vm$$route$query44 === void 0 ? void 0 : _vm$$route$query44.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.polLhv, _vm.formOperationalActivity.polDocOnBoard, 'Doc on Board', 'LHV', 7);
            }
          },
          model: {
            value: _vm.formOperationalActivity.polDocOnBoard,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polDocOnBoard", $$v);
            },
            expression: "formOperationalActivity.polDocOnBoard"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 7 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1) : _vm._e(), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Departure to POD",
            "label-for": "polDeparture"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query45 = _vm.$route.query) === null || _vm$$route$query45 === void 0 ? void 0 : _vm$$route$query45.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.polDocOnBoard, _vm.formOperationalActivity.polDeparture, 'Departure', 'Doc on Board', 8);
            }
          },
          model: {
            value: _vm.formOperationalActivity.polDeparture,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polDeparture", $$v);
            },
            expression: "formOperationalActivity.polDeparture"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 8 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Remarks",
            "label-for": "polCastIn"
          }
        }, [_c('b-form-textarea', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query46 = _vm.$route.query) === null || _vm$$route$query46 === void 0 ? void 0 : _vm$$route$query46.preview,
            "placeholder": "Type Text..."
          },
          model: {
            value: _vm.formOperationalActivity.polRemark,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polRemark", $$v);
            },
            expression: "formOperationalActivity.polRemark"
          }
        })], 1)], 1)], 1)], 1)]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("DISCHARGE ACTIVITY RECORD")])]), _c('b-form-row', [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Port of Discharge",
            "label-for": "port_of_discharge"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query47 = _vm.$route.query) === null || _vm$$route$query47 === void 0 ? void 0 : _vm$$route$query47.preview,
            "label": "text",
            "options": _vm.positionListPOD,
            "reduce": function reduce(positionListPOD) {
              return positionListPOD.value;
            },
            "placeholder": "Select..."
          },
          on: {
            "input": _vm.handleDestinationChange
          },
          model: {
            value: _vm.formOperationalActivity.portDischarge,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "portDischarge", $$v);
            },
            expression: "formOperationalActivity.portDischarge"
          }
        })], 1)], 1), ['Other'].includes(_vm.formOperationalActivity.portDischarge) ? _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Other POD",
            "label-for": "PODF"
          }
        }, [_c('b-form-input', {
          staticClass: "bg-white",
          attrs: {
            "type": "text",
            "disabled": (_vm$$route$query48 = _vm.$route.query) === null || _vm$$route$query48 === void 0 ? void 0 : _vm$$route$query48.preview
          },
          on: {
            "blur": function blur() {
              return _vm.formOperationalActivity.destinationOther = _vm.formOperationalActivity.portDischargeOther;
            }
          },
          model: {
            value: _vm.formOperationalActivity.portDischargeOther,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "portDischargeOther", $$v);
            },
            expression: "formOperationalActivity.portDischargeOther"
          }
        })], 1)], 1) : _vm._e(), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate",
          attrs: {
            "label": "Agent POD",
            "label-for": "agent_pod"
          }
        }, [_c('b-form-input', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query49 = _vm.$route.query) === null || _vm$$route$query49 === void 0 ? void 0 : _vm$$route$query49.preview,
            "type": "text",
            "id": "agent_pod",
            "placeholder": "Type Text"
          },
          on: {
            "change": function change() {
              _vm.formOperationalActivity.agentPol = _vm.formOperationalActivity.agentPod;
            }
          },
          model: {
            value: _vm.formOperationalActivity.agentPod,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "agentPod", $$v);
            },
            expression: "formOperationalActivity.agentPod"
          }
        })], 1)], 1), ['Other'].includes(_vm.formOperationalActivity.portDischarge) ? _c('b-col', {
          attrs: {
            "md": "6"
          }
        }) : _vm._e(), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Is Pod Sts Mv:",
            "label-for": "pod_sts_mv"
          }
        }, [_c('b-form-checkbox', {
          key: _vm.index,
          attrs: {
            "disabled": (_vm$$route$query50 = _vm.$route.query) === null || _vm$$route$query50 === void 0 ? void 0 : _vm$$route$query50.preview,
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          model: {
            value: _vm.formOperationalActivity.podStsMv,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podStsMv", $$v);
            },
            expression: "formOperationalActivity.podStsMv"
          }
        }, [_vm._v(" No / Yes ")])], 1)], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_vm.formOperationalActivity.podStsMv ? _c('b-form-group', {
          staticClass: "text-truncate",
          attrs: {
            "label": "Pod Mv Name",
            "label-for": "pod_mv_name"
          }
        }, [_c('b-form-input', {
          class: {
            'bg-white': _vm.formOperationalActivity.podStsMv
          },
          attrs: {
            "type": "text",
            "id": "pol_mv_name",
            "placeholder": "Type Text",
            "disabled": !_vm.formOperationalActivity.podStsMv || ((_vm$$route$query51 = _vm.$route.query) === null || _vm$$route$query51 === void 0 ? void 0 : _vm$$route$query51.preview)
          },
          model: {
            value: _vm.formOperationalActivity.podMvName,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podMvName", $$v);
            },
            expression: "formOperationalActivity.podMvName"
          }
        })], 1) : _vm._e()], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Pod grab Type",
            "label-for": "pod_grab_type"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query52 = _vm.$route.query) === null || _vm$$route$query52 === void 0 ? void 0 : _vm$$route$query52.preview,
            "label": "text",
            "options": _vm.polGrabTypeOpt,
            "reduce": function reduce(item) {
              return item.value;
            },
            "placeholder": "Select POd Grab Type"
          },
          model: {
            value: _vm.formOperationalActivity.podGrabType,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podGrabType", $$v);
            },
            expression: "formOperationalActivity.podGrabType"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_vm.formOperationalActivity.podGrabType == 'gearless' ? _c('b-form-group', {
          staticClass: "text-truncate",
          attrs: {
            "label": "Pod Fc Name",
            "label-for": "pod_fc_name"
          }
        }, [_c('b-form-input', {
          class: {
            'bg-white': _vm.formOperationalActivity.podGrabType == 'gearless'
          },
          attrs: {
            "disabled": _vm.formOperationalActivity.podGrabType !== 'gearless' || ((_vm$$route$query53 = _vm.$route.query) === null || _vm$$route$query53 === void 0 ? void 0 : _vm$$route$query53.preview),
            "type": "text",
            "id": "pol_mv_name",
            "placeholder": "Type Text"
          },
          model: {
            value: _vm.formOperationalActivity.podFcName,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podFcName", $$v);
            },
            expression: "formOperationalActivity.podFcName"
          }
        })], 1) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate",
          attrs: {
            "label": "Arrival Time POD",
            "label-for": "arrival_time_pod"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query54 = _vm.$route.query) === null || _vm$$route$query54 === void 0 ? void 0 : _vm$$route$query54.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.currentValidTime, _vm.formOperationalActivity.podArrivalTime);
            }
          },
          model: {
            value: _vm.formOperationalActivity.podArrivalTime,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podArrivalTime", $$v);
            },
            expression: "formOperationalActivity.podArrivalTime"
          }
        })], 1)], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "NOR",
            "label-for": "nor"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query55 = _vm.$route.query) === null || _vm$$route$query55 === void 0 ? void 0 : _vm$$route$query55.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          model: {
            value: _vm.formOperationalActivity.podNor,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podNor", $$v);
            },
            expression: "formOperationalActivity.podNor"
          }
        })], 1)], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "NOA",
            "label-for": "noa"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query56 = _vm.$route.query) === null || _vm$$route$query56 === void 0 ? void 0 : _vm$$route$query56.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          model: {
            value: _vm.formOperationalActivity.podNoa,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podNoa", $$v);
            },
            expression: "formOperationalActivity.podNoa"
          }
        })], 1)], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Anchor Up",
            "label-for": "podAnchorUp"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query57 = _vm.$route.query) === null || _vm$$route$query57 === void 0 ? void 0 : _vm$$route$query57.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.podArrivalTime, _vm.formOperationalActivity.podAnchorUp, 'Anchor Up', 'Arrival Time', 11);
            }
          },
          model: {
            value: _vm.formOperationalActivity.podAnchorUp,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podAnchorUp", $$v);
            },
            expression: "formOperationalActivity.podAnchorUp"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 11 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "In Position / Berthing",
            "label-for": "in_position_pod"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query58 = _vm.$route.query) === null || _vm$$route$query58 === void 0 ? void 0 : _vm$$route$query58.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.podAnchorUp, _vm.formOperationalActivity.podBerthing, 'Berthing', 'Anchor Up', 12);
            }
          },
          model: {
            value: _vm.formOperationalActivity.podBerthing,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podBerthing", $$v);
            },
            expression: "formOperationalActivity.podBerthing"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 12 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Commenced",
            "label-for": "commenced_pod"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query59 = _vm.$route.query) === null || _vm$$route$query59 === void 0 ? void 0 : _vm$$route$query59.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.podBerthing, _vm.formOperationalActivity.podCommenced, 'Commenced', 'Berthing', 13);
            }
          },
          model: {
            value: _vm.formOperationalActivity.podCommenced,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podCommenced", $$v);
            },
            expression: "formOperationalActivity.podCommenced"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 13 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Completed",
            "label-for": "completed_pod"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query60 = _vm.$route.query) === null || _vm$$route$query60 === void 0 ? void 0 : _vm$$route$query60.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.podCommenced, _vm.formOperationalActivity.podCompleted, 'Completed', 'Commenced', 14);
            }
          },
          model: {
            value: _vm.formOperationalActivity.podCompleted,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podCompleted", $$v);
            },
            expression: "formOperationalActivity.podCompleted"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 14 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Draught Survey",
            "label-for": "podDraughtSurvey"
          }
        }, [_c('InputCurrency', {
          attrs: {
            "prepend": "",
            "disabled": (_vm$$route$query61 = _vm.$route.query) === null || _vm$$route$query61 === void 0 ? void 0 : _vm$$route$query61.preview,
            "placeholder": "Type Number"
          },
          model: {
            value: _vm.formOperationalActivity.podDraughtSurvey,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podDraughtSurvey", $$v);
            },
            expression: "formOperationalActivity.podDraughtSurvey"
          }
        })], 1)], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Second Berthing",
            "label-for": "polCastIn"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query62 = _vm.$route.query) === null || _vm$$route$query62 === void 0 ? void 0 : _vm$$route$query62.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          model: {
            value: _vm.formOperationalActivity.podCastIn,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podCastIn", $$v);
            },
            expression: "formOperationalActivity.podCastIn"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 5 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Cast Out",
            "label-for": "podCastOut"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query63 = _vm.$route.query) === null || _vm$$route$query63 === void 0 ? void 0 : _vm$$route$query63.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.podCompleted, _vm.formOperationalActivity.podCastOut, 'Cast Out', 'Completed', 15);
            }
          },
          model: {
            value: _vm.formOperationalActivity.podCastOut,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podCastOut", $$v);
            },
            expression: "formOperationalActivity.podCastOut"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 15 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _vm.showDocumentOnBoard ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Document On Board POD",
            "label-for": "document_on_board_pod"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query64 = _vm.$route.query) === null || _vm$$route$query64 === void 0 ? void 0 : _vm$$route$query64.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          on: {
            "change": function change($event) {
              return _vm.validationTime(_vm.formOperationalActivity.podLhv, _vm.formOperationalActivity.podDocOnBoard, 'Doc on Board', 'LHV', 7);
            }
          },
          model: {
            value: _vm.formOperationalActivity.podDocOnBoard,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podDocOnBoard", $$v);
            },
            expression: "formOperationalActivity.podDocOnBoard"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 7 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1) : _vm._e(), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Departure to POL",
            "label-for": "podDeparture"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query65 = _vm.$route.query) === null || _vm$$route$query65 === void 0 ? void 0 : _vm$$route$query65.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          model: {
            value: _vm.formOperationalActivity.podDeparture,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podDeparture", $$v);
            },
            expression: "formOperationalActivity.podDeparture"
          }
        })], 1), _vm.errorTimeText && _vm.errorTimeIndex === 18 ? _c('small', {
          staticClass: "text-danger",
          staticStyle: {
            "margin-top": "-30px"
          }
        }, [_vm._v("*" + _vm._s(_vm.errorTimeText))]) : _vm._e()], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Remarks",
            "label-for": "polCastIn"
          }
        }, [_c('b-form-textarea', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query66 = _vm.$route.query) === null || _vm$$route$query66 === void 0 ? void 0 : _vm$$route$query66.preview,
            "placeholder": "Type Text..."
          },
          model: {
            value: _vm.formOperationalActivity.podRemark,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "podRemark", $$v);
            },
            expression: "formOperationalActivity.podRemark"
          }
        })], 1)], 1)], 1)], 1)]), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('hr')]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("PROCESS ACTIVITY")])]), [_c('b-form-group', {
          attrs: {
            "label": "Current Activity *",
            "label-for": "reason"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": ((_vm$$route$query67 = _vm.$route.query) === null || _vm$$route$query67 === void 0 ? void 0 : _vm$$route$query67.preview) || _vm.isEdit && _vm.formOperationalActivity.reasonId == '14|Unloading',
            "label": "text",
            "options": _vm.reasonList,
            "reduce": function reduce(reasonList) {
              return reasonList.value + '|' + reasonList.text;
            },
            "placeholder": "Select Current Activity"
          },
          on: {
            "input": _vm.handleChangeReason
          },
          model: {
            value: _vm.formOperationalActivity.reasonId,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "reasonId", $$v);
            },
            expression: "formOperationalActivity.reasonId"
          }
        })], 1), _vm.formOperationalActivity.reasonId && _vm.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? _c('b-form-row', {
          staticClass: "mb-3"
        }, [_c('b-col', [_vm.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? _c('b-form-group', {
          attrs: {
            "label": "Cargo Type teststsdffsdf*",
            "label-for": "cargo_type"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query68 = _vm.$route.query) === null || _vm$$route$query68 === void 0 ? void 0 : _vm$$route$query68.preview,
            "label": "text",
            "options": _vm.optionsCargoType,
            "reduce": function reduce(cargoOptions) {
              return cargoOptions.value;
            },
            "placeholder": "Select Type of Cargo"
          },
          on: {
            "input": _vm.handleCargoTypeChange
          },
          model: {
            value: _vm.formOperationalActivity.cargoType,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "cargoType", $$v);
            },
            expression: "formOperationalActivity.cargoType"
          }
        })], 1) : _vm._e()], 1), _vm.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? _c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Cargo Unit",
            "label-for": "polCargoUnit"
          }
        }, [_c('b-form-select', {
          staticClass: "bg-white",
          attrs: {
            "id": "polCargoUnit",
            "plain": "",
            "size": "md",
            "options": _vm.optionsUnit,
            "disabled": (_vm$$route$query69 = _vm.$route.query) === null || _vm$$route$query69 === void 0 ? void 0 : _vm$$route$query69.preview
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Select....")])];
            },
            proxy: true
          }], null, false, 2630454102),
          model: {
            value: _vm.formOperationalActivity.polCargoUnit,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polCargoUnit", $$v);
            },
            expression: "formOperationalActivity.polCargoUnit"
          }
        })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.formOperationalActivity.reasonId && _vm.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? _c('b-form-row', {
          staticClass: "mb-3"
        }, [_c('b-col', [_c('label', [_vm._v("Cargo Loading *")]), _c('InputCurrency', {
          attrs: {
            "append": _vm.formOperationalActivity.polCargoUnit || 'N/A',
            "prepend": "",
            "disabled": ((_vm$$route$query70 = _vm.$route.query) === null || _vm$$route$query70 === void 0 ? void 0 : _vm$$route$query70.preview) || _vm.isEdit,
            "placeholder": "Type Number"
          },
          model: {
            value: _vm.formOperationalActivity.cargoLoading,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "cargoLoading", $$v);
            },
            expression: "formOperationalActivity.cargoLoading"
          }
        })], 1)], 1) : _vm._e(), _vm.formOperationalActivity.reasonId && _vm.formOperationalActivity.reasonId.split('|')[1] === 'Unloading' ? _c('b-form-row', {
          staticClass: "mb-3"
        }, [_c('b-col', [_c('label', [_vm._v("Cargo Unloading *")]), _c('InputCurrency', {
          attrs: {
            "append": 'Ton',
            "prepend": "",
            "placeholder": "Type Number"
          },
          model: {
            value: _vm.formOperationalActivity.cargoUnloading,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "cargoUnloading", $$v);
            },
            expression: "formOperationalActivity.cargoUnloading"
          }
        })], 1), _c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Is End Trip:",
            "label-for": "kind-fleet"
          }
        }, [_c('b-form-checkbox', {
          key: _vm.index,
          attrs: {
            "disabled": ((_vm$$route$query71 = _vm.$route.query) === null || _vm$$route$query71 === void 0 ? void 0 : _vm$$route$query71.preview) || _vm.isEdit && _vm.formOperationalActivity.reasonId == '14|Unloading',
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          model: {
            value: _vm.formOperationalActivity.endOfTrip,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "endOfTrip", $$v);
            },
            expression: "formOperationalActivity.endOfTrip"
          }
        }, [_vm._v(" No / Yes ")])], 1)], 1)], 1) : _vm._e(), _c('b-form-group', {
          attrs: {
            "label": "Remarks",
            "label-for": "remarks"
          }
        }, [_c('b-form-textarea', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query72 = _vm.$route.query) === null || _vm$$route$query72 === void 0 ? void 0 : _vm$$route$query72.preview,
            "id": "description",
            "rows": "5"
          },
          model: {
            value: _vm.formOperationalActivity.remarks,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "remarks", $$v);
            },
            expression: "formOperationalActivity.remarks"
          }
        }), _c('small', {
          staticStyle: {
            "float": "left"
          }
        }, [_c('i', {
          staticClass: "fa fa-warning"
        }), _vm._v(" Max 500 Character")])], 1)]], 2)]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("POSITION & PIC")])]), _c('b-form-row', [_c('b-col', {
          class: _vm.formOperationalActivity.currentPosition === 'Other' ? 'col-md-6' : ''
        }, [_c('b-form-group', {
          attrs: {
            "label": "Current Position *",
            "label-for": "current_position"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query73 = _vm.$route.query) === null || _vm$$route$query73 === void 0 ? void 0 : _vm$$route$query73.preview,
            "label": "text",
            "options": _vm.positionListTextPOL,
            "reduce": function reduce(positionListTextPOL) {
              return positionListTextPOL.value;
            },
            "placeholder": "Select Position"
          },
          model: {
            value: _vm.formOperationalActivity.currentPosition,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "currentPosition", $$v);
            },
            expression: "formOperationalActivity.currentPosition"
          }
        })], 1)], 1), _vm.formOperationalActivity.currentPosition === 'Other' ? _c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Other Position ",
            "label-for": "other_position"
          }
        }, [_c('b-form-input', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query74 = _vm.$route.query) === null || _vm$$route$query74 === void 0 ? void 0 : _vm$$route$query74.preview,
            "type": "text"
          },
          model: {
            value: _vm.formOperationalActivity.currentPositionOther,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "currentPositionOther", $$v);
            },
            expression: "formOperationalActivity.currentPositionOther"
          }
        })], 1)], 1) : _vm._e(), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "PIC / PE *",
            "label-for": "pic"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query75 = _vm.$route.query) === null || _vm$$route$query75 === void 0 ? void 0 : _vm$$route$query75.preview,
            "label": "text",
            "options": _vm.picList,
            "reduce": function reduce(picList) {
              return picList.value;
            },
            "placeholder": "Select PIC",
            "multiple": true
          },
          model: {
            value: _vm.picSelected,
            callback: function callback($$v) {
              _vm.picSelected = $$v;
            },
            expression: "picSelected"
          }
        })], 1)], 1)], 1), _c('b-form-row')], 1), _c('b-card-text', {
          staticStyle: {
            "margin-top": "-18px"
          }
        }, [_c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Sign * : "), _c('b-badge', {
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v("Mandatory (Must be Input)")])], 1)])], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('hr')])], 1)], 1) : _vm._e(), _vm.formOperationalActivity.activityType === 'non trip' ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("PROJECT RECORD")])]), _c('b-form', [_c('b-form-group', {
          attrs: {
            "label": "Project *",
            "label-for": "project"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "options": _vm.projectOptions,
            "reduce": function reduce(option) {
              return option.value;
            },
            "placeholder": "Select one",
            "track-by": "value",
            "label": "text",
            "disabled": (_vm$$route$query76 = _vm.$route.query) === null || _vm$$route$query76 === void 0 ? void 0 : _vm$$route$query76.preview,
            "required": ""
          },
          on: {
            "input": _vm.handleChangeProject
          },
          model: {
            value: _vm.formOperationalActivity.subProjectId,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "subProjectId", $$v);
            },
            expression: "formOperationalActivity.subProjectId"
          }
        })], 1)], 1)], 1)]), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('hr')]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("PROCESS ACTIVITY")])]), [_c('b-form-group', {
          attrs: {
            "label": "Current Activity *",
            "label-for": "reason"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query77 = _vm.$route.query) === null || _vm$$route$query77 === void 0 ? void 0 : _vm$$route$query77.preview,
            "label": "text",
            "options": _vm.reasonList,
            "reduce": function reduce(reasonList) {
              return reasonList.value + '|' + reasonList.text;
            },
            "placeholder": "Select Current Activity"
          },
          on: {
            "input": _vm.handleChangeReason
          },
          model: {
            value: _vm.formOperationalActivity.reasonId,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "reasonId", $$v);
            },
            expression: "formOperationalActivity.reasonId"
          }
        })], 1), _vm.formOperationalActivity.reasonId && _vm.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? _c('b-form-row', {
          staticClass: "mb-3"
        }, [_c('b-col', [_vm.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? _c('b-form-group', {
          attrs: {
            "label": "Cargo Type *",
            "label-for": "cargo_type"
          }
        }, [_c('v-select', {
          attrs: {
            "disabled": (_vm$$route$query78 = _vm.$route.query) === null || _vm$$route$query78 === void 0 ? void 0 : _vm$$route$query78.preview,
            "label": "text",
            "options": _vm.optionsCargoType,
            "reduce": function reduce(cargoOptions) {
              return cargoOptions.value;
            },
            "placeholder": "Select Type of Cargo"
          },
          model: {
            value: _vm.formOperationalActivity.cargoType,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "cargoType", $$v);
            },
            expression: "formOperationalActivity.cargoType"
          }
        })], 1) : _vm._e()], 1), _vm.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? _c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Cargo Unit",
            "label-for": "polCargoUnit"
          }
        }, [_c('b-form-select', {
          attrs: {
            "id": "polCargoUnit",
            "plain": "",
            "size": "md",
            "options": _vm.optionsUnit,
            "disabled": (_vm$$route$query79 = _vm.$route.query) === null || _vm$$route$query79 === void 0 ? void 0 : _vm$$route$query79.preview
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Select....")])];
            },
            proxy: true
          }], null, false, 2630454102),
          model: {
            value: _vm.formOperationalActivity.polCargoUnit,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polCargoUnit", $$v);
            },
            expression: "formOperationalActivity.polCargoUnit"
          }
        })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.formOperationalActivity.reasonId && _vm.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? _c('b-form-row', {
          staticClass: "mb-3"
        }, [_c('b-col', [_c('b-form-group', {
          staticClass: "d-flex flex-column",
          attrs: {
            "label": "Cargo Loading *",
            "label-for": "cargo_loading"
          }
        }, [_c('b-input-group', {
          attrs: {
            "size": "md",
            "append": _vm.formOperationalActivity.polCargoUnit || 'N/A'
          }
        }, [_c('b-form-input', {
          attrs: {
            "disabled": (_vm$$route$query80 = _vm.$route.query) === null || _vm$$route$query80 === void 0 ? void 0 : _vm$$route$query80.preview,
            "type": "number",
            "step": "0.0001"
          },
          model: {
            value: _vm.formOperationalActivity.cargoLoading,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "cargoLoading", $$v);
            },
            expression: "formOperationalActivity.cargoLoading"
          }
        })], 1), _c('span', {
          staticClass: "text-black"
        }, [_vm._v(_vm._s((_vm$formOperationalAc = _vm.formOperationalActivity) !== null && _vm$formOperationalAc !== void 0 && _vm$formOperationalAc.cargoLoading ? Number((_vm$formOperationalAc2 = _vm.formOperationalActivity) === null || _vm$formOperationalAc2 === void 0 ? void 0 : _vm$formOperationalAc2.cargoLoading).toLocaleString() : 0) + " " + _vm._s(_vm.formOperationalActivity.polCargoUnit))]), _c('br'), _c('small', {
          staticClass: "text-warning",
          staticStyle: {
            "float": "left"
          }
        }, [_c('i', {
          staticClass: "fa fa-warning"
        }), _vm._v(" Type Number")])], 1)], 1)], 1) : _vm._e(), _vm.formOperationalActivity.reasonId && _vm.formOperationalActivity.reasonId.split('|')[1] === 'Unloading' ? _c('b-form-row', {
          staticClass: "mb-3"
        }, [_c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Cargo Unloading *",
            "label-for": "cargo_unloading"
          }
        }, [_c('b-input-group', {
          attrs: {
            "size": "md",
            "append": "Ton"
          }
        }, [_c('b-form-input', {
          attrs: {
            "disabled": (_vm$$route$query81 = _vm.$route.query) === null || _vm$$route$query81 === void 0 ? void 0 : _vm$$route$query81.preview,
            "type": "number"
          },
          model: {
            value: _vm.formOperationalActivity.cargoUnloading,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "cargoUnloading", $$v);
            },
            expression: "formOperationalActivity.cargoUnloading"
          }
        })], 1), _c('span', {
          staticClass: "text-black"
        }, [_vm._v(_vm._s((_vm$formOperationalAc3 = _vm.formOperationalActivity) !== null && _vm$formOperationalAc3 !== void 0 && _vm$formOperationalAc3.cargoUnloading ? Number((_vm$formOperationalAc4 = _vm.formOperationalActivity) === null || _vm$formOperationalAc4 === void 0 ? void 0 : _vm$formOperationalAc4.cargoUnloading).toLocaleString() : 0) + " Ton")]), _c('br'), _c('small', {
          staticClass: "text-warning",
          staticStyle: {
            "float": "left"
          }
        }, [_c('i', {
          staticClass: "fa fa-warning"
        }), _vm._v(" Type Number")])], 1)], 1), _c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Is End Trip:",
            "label-for": "kind-fleet"
          }
        }, [_c('b-form-checkbox', {
          key: _vm.index,
          attrs: {
            "disabled": (_vm$$route$query82 = _vm.$route.query) === null || _vm$$route$query82 === void 0 ? void 0 : _vm$$route$query82.preview,
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          model: {
            value: _vm.formOperationalActivity.endOfTrip,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "endOfTrip", $$v);
            },
            expression: "formOperationalActivity.endOfTrip"
          }
        }, [_vm._v(" No / Yes ")])], 1)], 1)], 1) : _vm._e(), _c('b-form-group', {
          attrs: {
            "label": "Remarks",
            "label-for": "remarks"
          }
        }, [_c('b-form-textarea', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query83 = _vm.$route.query) === null || _vm$$route$query83 === void 0 ? void 0 : _vm$$route$query83.preview,
            "id": "description",
            "rows": "5"
          },
          model: {
            value: _vm.formOperationalActivity.remarks,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "remarks", $$v);
            },
            expression: "formOperationalActivity.remarks"
          }
        }), _c('small', {
          staticStyle: {
            "float": "left"
          }
        }, [_c('i', {
          staticClass: "fa fa-warning"
        }), _vm._v(" Max 500 Character")])], 1)]], 2)]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("POSITION & PIC")])]), _c('b-form-row', [_c('b-col', {
          class: _vm.formOperationalActivity.currentPosition === 'Other' ? 'col-md-6' : ''
        }, [_c('b-form-group', {
          attrs: {
            "label": "Current Position *",
            "label-for": "current_position"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query84 = _vm.$route.query) === null || _vm$$route$query84 === void 0 ? void 0 : _vm$$route$query84.preview,
            "label": "text",
            "options": _vm.positionListTextPOL,
            "reduce": function reduce(positionListTextPOL) {
              return positionListTextPOL.value;
            },
            "placeholder": "Select Position"
          },
          model: {
            value: _vm.formOperationalActivity.currentPosition,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "currentPosition", $$v);
            },
            expression: "formOperationalActivity.currentPosition"
          }
        })], 1)], 1), _vm.formOperationalActivity.currentPosition === 'Other' ? _c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Other Position ",
            "label-for": "other_position"
          }
        }, [_c('b-form-input', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query85 = _vm.$route.query) === null || _vm$$route$query85 === void 0 ? void 0 : _vm$$route$query85.preview,
            "type": "text"
          },
          model: {
            value: _vm.formOperationalActivity.currentPositionOther,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "currentPositionOther", $$v);
            },
            expression: "formOperationalActivity.currentPositionOther"
          }
        })], 1)], 1) : _vm._e(), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "PIC / PE *",
            "label-for": "pic"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query86 = _vm.$route.query) === null || _vm$$route$query86 === void 0 ? void 0 : _vm$$route$query86.preview,
            "label": "text",
            "options": _vm.picList,
            "reduce": function reduce(picList) {
              return picList.value;
            },
            "placeholder": "Select PIC",
            "multiple": true
          },
          model: {
            value: _vm.picSelected,
            callback: function callback($$v) {
              _vm.picSelected = $$v;
            },
            expression: "picSelected"
          }
        })], 1)], 1)], 1), _c('b-form-row')], 1), _c('b-card-text', {
          staticStyle: {
            "margin-top": "-18px"
          }
        }, [_c('small', {
          staticClass: "text-muted mb-3"
        }, [_vm._v("Sign * : "), _c('b-badge', {
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v("Mandatory (Must be Input)")])], 1)])], 1)], 1)], 1) : _vm._e(), !_vm.formOperationalActivity.activityType && !((_vm$formOperationalAc5 = _vm.formOperationalActivity) !== null && _vm$formOperationalAc5 !== void 0 && _vm$formOperationalAc5.tripId) ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("PROJECT RECORD")])]), _c('b-form', [_c('b-form-group', {
          attrs: {
            "label": "Project *",
            "label-for": "project"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "options": _vm.projectOptions,
            "reduce": function reduce(option) {
              return option.value;
            },
            "placeholder": "Select one",
            "track-by": "value",
            "label": "text",
            "disabled": (_vm$$route$query87 = _vm.$route.query) === null || _vm$$route$query87 === void 0 ? void 0 : _vm$$route$query87.preview,
            "required": ""
          },
          on: {
            "input": _vm.handleChangeProject
          },
          model: {
            value: _vm.formOperationalActivity.subProjectId,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "subProjectId", $$v);
            },
            expression: "formOperationalActivity.subProjectId"
          }
        })], 1)], 1)], 1)]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("POSITION")])]), _c('b-form-row', [_c('b-col', {
          class: _vm.formOperationalActivity.currentPosition === 'Other' ? 'col-md-6' : ''
        }, [_c('b-form-group', {
          attrs: {
            "label": "Current Position *",
            "label-for": "current_position"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query88 = _vm.$route.query) === null || _vm$$route$query88 === void 0 ? void 0 : _vm$$route$query88.preview,
            "label": "text",
            "options": _vm.positionListTextPOL,
            "reduce": function reduce(positionListTextPOL) {
              return positionListTextPOL.value;
            },
            "placeholder": "Select Position"
          },
          model: {
            value: _vm.formOperationalActivity.currentPosition,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "currentPosition", $$v);
            },
            expression: "formOperationalActivity.currentPosition"
          }
        })], 1)], 1), _vm.formOperationalActivity.currentPosition === 'Other' ? _c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Other Position ",
            "label-for": "other_position"
          }
        }, [_c('b-form-input', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query89 = _vm.$route.query) === null || _vm$$route$query89 === void 0 ? void 0 : _vm$$route$query89.preview,
            "type": "text"
          },
          model: {
            value: _vm.formOperationalActivity.currentPositionOther,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "currentPositionOther", $$v);
            },
            expression: "formOperationalActivity.currentPositionOther"
          }
        })], 1)], 1) : _vm._e()], 1), _c('b-form-row')], 1), _c('b-card-text', {
          staticStyle: {
            "margin-top": "-18px"
          }
        }, [_c('small', {
          staticClass: "text-muted mb-3"
        }, [_vm._v("Sign * : "), _c('b-badge', {
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v("Mandatory (Must be Input)")])], 1)]), _c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("PIC")])]), _vm.showPIC ? _c('b-form-row', [_c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "PIC / PE *",
            "label-for": "pic"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query90 = _vm.$route.query) === null || _vm$$route$query90 === void 0 ? void 0 : _vm$$route$query90.preview,
            "label": "text",
            "options": _vm.picList,
            "reduce": function reduce(picList) {
              return picList.value;
            },
            "placeholder": "Select PIC",
            "multiple": true
          },
          model: {
            value: _vm.picSelected,
            callback: function callback($$v) {
              _vm.picSelected = $$v;
            },
            expression: "picSelected"
          }
        })], 1)], 1)], 1) : _vm._e()], 1), _c('b-card-text', {
          staticStyle: {
            "margin-top": "-18px"
          }
        }, [_c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Sign * : "), _c('b-badge', {
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v("Mandatory (Must be Input)")])], 1)])], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('hr')]), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("ACTIVITY RECORD")])]), _c('b-form-row', [_c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Port of Loading",
            "label-for": "port_of_loading"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query91 = _vm.$route.query) === null || _vm$$route$query91 === void 0 ? void 0 : _vm$$route$query91.preview,
            "label": "text",
            "options": _vm.positionListPOL,
            "reduce": function reduce(positionListPOL) {
              return positionListPOL.value;
            },
            "placeholder": "Select..."
          },
          model: {
            value: _vm.formOperationalActivity.portLoading,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "portLoading", $$v);
            },
            expression: "formOperationalActivity.portLoading"
          }
        })], 1)], 1), ['Other'].includes(_vm.formOperationalActivity.portLoading) ? _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Other POL",
            "label-for": "POL"
          }
        }, [_c('b-form-input', {
          staticClass: "bg-white",
          attrs: {
            "type": "text",
            "disabled": (_vm$$route$query92 = _vm.$route.query) === null || _vm$$route$query92 === void 0 ? void 0 : _vm$$route$query92.preview
          },
          model: {
            value: _vm.formOperationalActivity.portLoadingOther,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "portLoadingOther", $$v);
            },
            expression: "formOperationalActivity.portLoadingOther"
          }
        })], 1)], 1) : _vm._e(), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Port of Discharge",
            "label-for": "port_of_discharge"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query93 = _vm.$route.query) === null || _vm$$route$query93 === void 0 ? void 0 : _vm$$route$query93.preview,
            "label": "text",
            "options": _vm.positionListPOD,
            "reduce": function reduce(positionListPOD) {
              return positionListPOD.value;
            },
            "placeholder": "Select..."
          },
          model: {
            value: _vm.formOperationalActivity.portDischarge,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "portDischarge", $$v);
            },
            expression: "formOperationalActivity.portDischarge"
          }
        })], 1)], 1), ['Other'].includes(_vm.formOperationalActivity.portDischarge) ? _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Other POD",
            "label-for": "PODF"
          }
        }, [_c('b-form-input', {
          staticClass: "bg-white",
          attrs: {
            "type": "text",
            "disabled": (_vm$$route$query94 = _vm.$route.query) === null || _vm$$route$query94 === void 0 ? void 0 : _vm$$route$query94.preview
          },
          model: {
            value: _vm.formOperationalActivity.portDischargeOther,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "portDischargeOther", $$v);
            },
            expression: "formOperationalActivity.portDischargeOther"
          }
        })], 1)], 1) : _vm._e(), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate",
          attrs: {
            "label": "Agent POL",
            "label-for": "agent_pol"
          }
        }, [_c('b-form-input', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query95 = _vm.$route.query) === null || _vm$$route$query95 === void 0 ? void 0 : _vm$$route$query95.preview,
            "type": "text",
            "id": "agent_pol",
            "placeholder": "Type Text"
          },
          model: {
            value: _vm.formOperationalActivity.agentPol,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "agentPol", $$v);
            },
            expression: "formOperationalActivity.agentPol"
          }
        })], 1)], 1), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate",
          attrs: {
            "label": "Agent POD",
            "label-for": "agent_pod"
          }
        }, [_c('b-form-input', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query96 = _vm.$route.query) === null || _vm$$route$query96 === void 0 ? void 0 : _vm$$route$query96.preview,
            "type": "text",
            "id": "agent_pod",
            "placeholder": "Type Text"
          },
          model: {
            value: _vm.formOperationalActivity.agentPod,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "agentPod", $$v);
            },
            expression: "formOperationalActivity.agentPod"
          }
        })], 1)], 1), ['Other'].includes(_vm.formOperationalActivity.portDischarge) ? _c('b-col', {
          attrs: {
            "md": "6"
          }
        }) : _vm._e(), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate",
          attrs: {
            "label": "ETA / Arrival",
            "label-for": "arrival_time_pod"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query97 = _vm.$route.query) === null || _vm$$route$query97 === void 0 ? void 0 : _vm$$route$query97.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          model: {
            value: _vm.formOperationalActivity.arrival,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "arrival", $$v);
            },
            expression: "formOperationalActivity.arrival"
          }
        })], 1)], 1), _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "6"
          }
        }, [_c('b-form-group', {
          staticClass: "text-truncate mb-0",
          attrs: {
            "label": "Departure",
            "label-for": "polDeparture"
          }
        }, [_c('date-picker', {
          staticClass: "custom-date-picker",
          attrs: {
            "disabled": (_vm$$route$query98 = _vm.$route.query) === null || _vm$$route$query98 === void 0 ? void 0 : _vm$$route$query98.preview,
            "value-type": "DD-MM-YYYY HH:mm",
            "type": "datetime",
            "placeholder": "Select date",
            "format": "DD-MM-YYYY HH:mm"
          },
          model: {
            value: _vm.formOperationalActivity.departure,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "departure", $$v);
            },
            expression: "formOperationalActivity.departure"
          }
        })], 1)], 1)], 1)], 1)]), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('hr')]), _c('b-col', {
          attrs: {
            "md": "6"
          }
        }, [_c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-info"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-primary h6"
        }, [_c('strong', [_vm._v("PROCESS ACTIVITY")])]), [_c('b-form-group', {
          attrs: {
            "label": "Current Activity *",
            "label-for": "reason"
          }
        }, [_c('v-select', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query99 = _vm.$route.query) === null || _vm$$route$query99 === void 0 ? void 0 : _vm$$route$query99.preview,
            "label": "text",
            "options": _vm.reasonList,
            "reduce": function reduce(reasonList) {
              return reasonList.value + '|' + reasonList.text;
            },
            "placeholder": "Select Current Activity"
          },
          on: {
            "input": _vm.handleChangeReason
          },
          model: {
            value: _vm.formOperationalActivity.reasonId,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "reasonId", $$v);
            },
            expression: "formOperationalActivity.reasonId"
          }
        })], 1), _vm.formOperationalActivity.reasonId && _vm.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? _c('b-form-row', {
          staticClass: "mb-3"
        }, [_c('b-col', [_vm.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? _c('b-form-group', {
          attrs: {
            "label": "Cargo Type *",
            "label-for": "cargo_type"
          }
        }, [_c('v-select', {
          attrs: {
            "disabled": (_vm$$route$query100 = _vm.$route.query) === null || _vm$$route$query100 === void 0 ? void 0 : _vm$$route$query100.preview,
            "label": "text",
            "options": _vm.optionsCargoType,
            "reduce": function reduce(cargoOptions) {
              return cargoOptions.value;
            },
            "placeholder": "Select Type of Cargo"
          },
          model: {
            value: _vm.formOperationalActivity.cargoType,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "cargoType", $$v);
            },
            expression: "formOperationalActivity.cargoType"
          }
        })], 1) : _vm._e()], 1), _vm.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? _c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Cargo Unit",
            "label-for": "polCargoUnit"
          }
        }, [_c('b-form-select', {
          attrs: {
            "id": "polCargoUnit",
            "plain": "",
            "size": "md",
            "options": _vm.optionsUnit,
            "disabled": (_vm$$route$query101 = _vm.$route.query) === null || _vm$$route$query101 === void 0 ? void 0 : _vm$$route$query101.preview
          },
          scopedSlots: _vm._u([{
            key: "first",
            fn: function fn() {
              return [_c('b-form-select-option', {
                attrs: {
                  "value": null
                }
              }, [_vm._v("Select....")])];
            },
            proxy: true
          }], null, false, 2630454102),
          model: {
            value: _vm.formOperationalActivity.polCargoUnit,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "polCargoUnit", $$v);
            },
            expression: "formOperationalActivity.polCargoUnit"
          }
        })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.formOperationalActivity.reasonId && _vm.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? _c('b-form-row', {
          staticClass: "mb-3"
        }, [_c('b-col', [_c('b-form-group', {
          staticClass: "d-flex flex-column",
          attrs: {
            "label": "Cargo Loading *",
            "label-for": "cargo_loading"
          }
        }, [_c('b-input-group', {
          attrs: {
            "size": "md",
            "append": _vm.formOperationalActivity.polCargoUnit || 'N/A'
          }
        }, [_c('b-form-input', {
          attrs: {
            "disabled": (_vm$$route$query102 = _vm.$route.query) === null || _vm$$route$query102 === void 0 ? void 0 : _vm$$route$query102.preview,
            "type": "number",
            "step": "0.0001"
          },
          model: {
            value: _vm.formOperationalActivity.cargoLoading,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "cargoLoading", $$v);
            },
            expression: "formOperationalActivity.cargoLoading"
          }
        })], 1), _c('span', {
          staticClass: "text-black"
        }, [_vm._v(_vm._s((_vm$formOperationalAc6 = _vm.formOperationalActivity) !== null && _vm$formOperationalAc6 !== void 0 && _vm$formOperationalAc6.cargoLoading ? Number((_vm$formOperationalAc7 = _vm.formOperationalActivity) === null || _vm$formOperationalAc7 === void 0 ? void 0 : _vm$formOperationalAc7.cargoLoading).toLocaleString() : 0) + " " + _vm._s(_vm.formOperationalActivity.polCargoUnit))]), _c('br'), _c('small', {
          staticClass: "text-warning",
          staticStyle: {
            "float": "left"
          }
        }, [_c('i', {
          staticClass: "fa fa-warning"
        }), _vm._v(" Type Number")])], 1)], 1)], 1) : _vm._e(), _vm.formOperationalActivity.reasonId && _vm.formOperationalActivity.reasonId.split('|')[1] === 'Unloading' ? _c('b-form-row', {
          staticClass: "mb-3"
        }, [_c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Cargo Unloading *",
            "label-for": "cargo_unloading"
          }
        }, [_c('b-input-group', {
          attrs: {
            "size": "md",
            "append": "Ton"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: _vm.formOperationalActivity.cargoUnloading,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "cargoUnloading", $$v);
            },
            expression: "formOperationalActivity.cargoUnloading"
          }
        })], 1), _c('span', {
          staticClass: "text-black"
        }, [_vm._v(_vm._s((_vm$formOperationalAc8 = _vm.formOperationalActivity) !== null && _vm$formOperationalAc8 !== void 0 && _vm$formOperationalAc8.cargoUnloading ? Number((_vm$formOperationalAc9 = _vm.formOperationalActivity) === null || _vm$formOperationalAc9 === void 0 ? void 0 : _vm$formOperationalAc9.cargoUnloading).toLocaleString() : 0) + " Ton")]), _c('br'), _c('small', {
          staticClass: "text-warning",
          staticStyle: {
            "float": "left"
          }
        }, [_c('i', {
          staticClass: "fa fa-warning"
        }), _vm._v(" Type Number")])], 1)], 1), _c('b-col', [_c('b-form-group', {
          attrs: {
            "label": "Is End Trip:",
            "label-for": "kind-fleet"
          }
        }, [_c('b-form-checkbox', {
          key: _vm.index,
          attrs: {
            "disabled": (_vm$$route$query103 = _vm.$route.query) === null || _vm$$route$query103 === void 0 ? void 0 : _vm$$route$query103.preview,
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          model: {
            value: _vm.formOperationalActivity.endOfTrip,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "endOfTrip", $$v);
            },
            expression: "formOperationalActivity.endOfTrip"
          }
        }, [_vm._v(" No / Yes ")])], 1)], 1)], 1) : _vm._e(), _c('b-form-group', {
          attrs: {
            "label": "Remarks",
            "label-for": "remarks"
          }
        }, [_c('b-form-textarea', {
          staticClass: "bg-white",
          attrs: {
            "disabled": (_vm$$route$query104 = _vm.$route.query) === null || _vm$$route$query104 === void 0 ? void 0 : _vm$$route$query104.preview,
            "id": "description",
            "rows": "5"
          },
          model: {
            value: _vm.formOperationalActivity.remarks,
            callback: function callback($$v) {
              _vm.$set(_vm.formOperationalActivity, "remarks", $$v);
            },
            expression: "formOperationalActivity.remarks"
          }
        }), _c('small', {
          staticStyle: {
            "float": "left"
          }
        }, [_c('i', {
          staticClass: "fa fa-warning"
        }), _vm._v(" Max 500 Character")])], 1)]], 2)])], 1)], 1) : _vm._e()] : _vm._e()], 2), !((_vm$$route2 = _vm.$route) !== null && _vm$$route2 !== void 0 && (_vm$$route2$query = _vm$$route2.query) !== null && _vm$$route2$query !== void 0 && _vm$$route2$query.preview) || ((_vm$$route3 = _vm.$route) === null || _vm$$route3 === void 0 ? void 0 : (_vm$$route3$query = _vm$$route3.query) === null || _vm$$route3$query === void 0 ? void 0 : _vm$$route3$query.preview) === false ? _c('b-col', {
          staticClass: "h-auto",
          attrs: {
            "cols": "4",
            "md": "4"
          }
        }, [_c('h5', {
          staticClass: "card-title text-primary mb-4"
        }, [_c('strong', [_vm._v("LAST OPERATIONAL")])]), _c('div', {
          staticClass: "m-0 px-3 overflow-auto",
          style: {
            height: _vm.timeLineHeigth + 'px',
            background: '#F6F2F8'
          }
        }, _vm._l(_vm.activityList, function (each) {
          var _Number3;
          return _c('div', {
            key: each.id,
            staticClass: "py-3",
            staticStyle: {
              "border-bottom": "1px solid"
            }
          }, [_c('b-row', {
            staticClass: "m-0 p-0"
          }, [_c('b-col', {
            staticClass: "border-b m-0 p-0",
            attrs: {
              "md": "11"
            }
          }, [_c('h6', {
            staticClass: "float-left text-dark"
          }, [_vm._v(" " + _vm._s(each !== null && each !== void 0 && each.startDate ? _vm.moment(each === null || each === void 0 ? void 0 : each.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-') + " - " + _vm._s(each !== null && each !== void 0 && each.endDate ? _vm.moment(each === null || each === void 0 ? void 0 : each.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-'))]), _c('div', {
            staticClass: "d-inline-block w-100 text-black text-truncate"
          }, [_c('b-badge', {
            staticClass: "mb-2",
            attrs: {
              "variant": "info"
            }
          }, [_c('i', {
            staticClass: "fa fa-clock"
          }), _vm._v(" " + _vm._s(each.activityDurationFormat) + " ")]), each.vehicle.length > 0 ? _c('div', {
            staticClass: "d-flex align-items-center mb-3"
          }, _vm._l(each.vehicle, function (fleet, fleetIdx) {
            return _c('div', {
              key: fleetIdx,
              staticClass: "d-flex align-items-center"
            }, [[_c('b-badge', {
              attrs: {
                "variant": "success"
              }
            }, [_vm._v(_vm._s(fleet === null || fleet === void 0 ? void 0 : fleet.name))]), fleetIdx !== each.vehicle.length - 1 ? _c('LinkIcon', {
              staticClass: "mx-2"
            }) : _vm._e()]], 2);
          }), 0) : _vm._e(), each.polTrip && each.podTrip && (each === null || each === void 0 ? void 0 : each.activityType) === 'trip' ? _c('div', {
            staticClass: "flex align-items-center text-primary mb-2 font-semibold"
          }, [_c('MapPinOutline', {
            staticClass: "mr-1"
          }), _c('span', [_vm._v(_vm._s(each.polTrip))]), _c('i', {
            staticClass: "fas fa-arrow-right mx-2"
          }), _c('MapPinOutline', {
            staticClass: "mr-1"
          }), _c('span', [_vm._v(_vm._s(each.podTrip))])], 1) : _vm._e(), !each.polTrip && !each.podTrip && (each === null || each === void 0 ? void 0 : each.activityType) === 'trip' ? _c('div', {
            staticClass: "d-flex align-items-center text-danger"
          }, [_c('i', {
            staticClass: "ri-close-circle-line mr-2"
          }), _vm._v(" Not Setup Trip ")]) : _vm._e(), (each === null || each === void 0 ? void 0 : each.activityType) === 'non trip' ? _c('div', {
            staticClass: "d-flex align-items-center text-danger"
          }, [_c('i', {
            staticClass: "ri-close-circle-line mr-2"
          }), _vm._v(" Non Trip ")]) : _vm._e(), !(each !== null && each !== void 0 && each.activityType) ? _c('div', {
            staticClass: "d-flex align-items-center text-danger"
          }, [_c('i', {
            staticClass: "ri-close-circle-line mr-2"
          }), _vm._v(" Not Available ")]) : _vm._e(), !(each !== null && each !== void 0 && each.cargo) ? _c('p', {
            staticClass: "mb-0"
          }, [_vm._v(_vm._s(each.activityName))]) : _c('p', {
            staticClass: "mb-0"
          }, [_vm._v(_vm._s(each.activityName) + ": "), _c('strong', [_vm._v(_vm._s((_Number3 = Number(each === null || each === void 0 ? void 0 : each.cargo)) === null || _Number3 === void 0 ? void 0 : _Number3.toLocaleString()))])])], 1)]), _c('b-col', {
            staticClass: "p-0 m-0",
            attrs: {
              "md": "1"
            }
          }, [_c('b-dropdown', {
            attrs: {
              "variant": "link iq-bg-primary iq-border-radius-10",
              "toggle-class": "text-decoration-none",
              "no-caret": ""
            },
            scopedSlots: _vm._u([{
              key: "button-content",
              fn: function fn() {
                return [_c('span', {
                  staticClass: "dropdown-toggle p-0",
                  attrs: {
                    "id": "dropdownMenuButton5",
                    "data-toggle": "dropdown"
                  }
                })];
              },
              proxy: true
            }], null, true)
          }, [_c('b-dropdown-item', {
            staticClass: "m-0 p-0",
            attrs: {
              "href": "#"
            },
            on: {
              "click": function click() {
                _vm.getActivityDetail(each.id, true);
                _vm.locked = true;
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-pencil-square-o mr-2"
          }), _vm._v("Edit")]), each.activityName !== 'Finish' ? _c('b-dropdown-item', {
            staticClass: "m-0 p-0",
            attrs: {
              "href": "#"
            },
            on: {
              "click": function click($event) {
                return _vm.onDeleteActivity(each);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-trash mr-2"
          }), _vm._v("Delete")]) : _vm._e()], 1)], 1)], 1)], 1);
        }), 0)]) : _vm._e(), !_vm.loadingOperational ? [_vm.nextStep && !_vm.loadingOperational && !_vm.isActivityId || _vm.isActivityId && !_vm.loadingOperational ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('b-form-checkbox', {
          staticClass: "mb-3",
          attrs: {
            "name": "check-button",
            "switch": "",
            "disabled": (_vm$$route$query105 = _vm.$route.query) === null || _vm$$route$query105 === void 0 ? void 0 : _vm$$route$query105.preview
          },
          on: {
            "change": _vm.handleUseShelter
          },
          model: {
            value: _vm.useShelter,
            callback: function callback($$v) {
              _vm.useShelter = $$v;
            },
            expression: "useShelter"
          }
        }, [_vm._v("Use Shelter? ")]), _vm.useShelter ? _c('fieldset', {
          staticClass: "form-group border p-3 iq-bg-warning"
        }, [_c('legend', {
          staticClass: "w-auto px-2 text-danger h6"
        }, [_c('strong', [_vm._v("SHELTER")])]), _c('b-row', [_c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "d-flex justify-content-end w-100 m-0"
        }, [_c('b-button', {
          staticClass: "mb-2",
          attrs: {
            "variant": "primary",
            "type": "button"
          },
          on: {
            "click": _vm.addShelter
          }
        }, [_vm._v("Add Shelter "), _c('i', {
          staticClass: "fa fa-plus"
        })])], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "d-flex w-100 border mb-2"
        })]), _vm._l(_vm.formOperationalActivity.shelter, function (val, index) {
          var _vm$$route$query106, _vm$$route$query107, _vm$$route$query108, _vm$$route$query109, _vm$$route$query110, _vm$$route$query111, _vm$$route$query112, _vm$$route$query113, _vm$$route$query114, _vm$$route$query115;
          return _c('b-row', {
            key: index
          }, [_c('b-col', {
            attrs: {
              "md": "2"
            }
          }, [_c('b-form-group', {
            attrs: {
              "label": "Shelter For",
              "label-for": "shelter_for"
            }
          }, [_c('b-form-select', {
            staticStyle: {
              "background-color": "#ffffff"
            },
            attrs: {
              "disabled": (_vm$$route$query106 = _vm.$route.query) === null || _vm$$route$query106 === void 0 ? void 0 : _vm$$route$query106.preview,
              "plain": "",
              "size": "sm"
            },
            scopedSlots: _vm._u([{
              key: "first",
              fn: function fn() {
                return [_c('b-form-select-option', {
                  attrs: {
                    "value": ''
                  }
                }, [_vm._v("Select...")]), _c('b-form-select-option', {
                  attrs: {
                    "value": 'loading'
                  }
                }, [_vm._v("Loading")]), _c('b-form-select-option', {
                  attrs: {
                    "value": 'discharge'
                  }
                }, [_vm._v("Discharge")]), _c('b-form-select-option', {
                  attrs: {
                    "value": 'others'
                  }
                }, [_vm._v("Others")])];
              },
              proxy: true
            }], null, true),
            model: {
              value: val.shelterFor,
              callback: function callback($$v) {
                _vm.$set(val, "shelterFor", $$v);
              },
              expression: "val.shelterFor"
            }
          })], 1)], 1), ['others'].includes(val.shelterFor) ? _c('b-col', {
            attrs: {
              "md": "2"
            }
          }, [_c('b-form-group', {
            attrs: {
              "label": "Shelter For Other",
              "label-for": "shelterForOther"
            }
          }, [_c('b-form-input', {
            staticClass: "bg-white",
            attrs: {
              "type": "text",
              "disabled": (_vm$$route$query107 = _vm.$route.query) === null || _vm$$route$query107 === void 0 ? void 0 : _vm$$route$query107.preview
            },
            model: {
              value: val.shelterForOtherValue,
              callback: function callback($$v) {
                _vm.$set(val, "shelterForOtherValue", $$v);
              },
              expression: "val.shelterForOtherValue"
            }
          })], 1)], 1) : _vm._e(), _c('b-col', {
            attrs: {
              "md": ['Other'].includes(val.shelterLocation) ? '4' : '2'
            }
          }, [_c('b-form-group', {
            attrs: {
              "label": "Shelter Location",
              "label-for": "shelter_location"
            }
          }, [_c('div', {
            staticClass: "d-flex"
          }, [_c('v-select', {
            staticClass: "mr-2",
            staticStyle: {
              "background-color": "#ffffff",
              "width": "200px"
            },
            attrs: {
              "label": "text",
              "options": _vm.positionListTextPOL,
              "reduce": function reduce(positionListTextPOL) {
                return positionListTextPOL.value;
              },
              "placeholder": "Select...",
              "disabled": (_vm$$route$query108 = _vm.$route.query) === null || _vm$$route$query108 === void 0 ? void 0 : _vm$$route$query108.preview
            },
            model: {
              value: val.shelterLocation,
              callback: function callback($$v) {
                _vm.$set(val, "shelterLocation", $$v);
              },
              expression: "val.shelterLocation"
            }
          }), ['Other'].includes(val.shelterLocation) ? _c('b-form-input', {
            staticStyle: {
              "background-color": "#ffffff",
              "width": "200px"
            },
            attrs: {
              "type": "text",
              "placeholder": "Other shelter...",
              "disabled": (_vm$$route$query109 = _vm.$route.query) === null || _vm$$route$query109 === void 0 ? void 0 : _vm$$route$query109.preview
            },
            model: {
              value: val.shelterLocationOther,
              callback: function callback($$v) {
                _vm.$set(val, "shelterLocationOther", $$v);
              },
              expression: "val.shelterLocationOther"
            }
          }) : _vm._e()], 1)])], 1), _c('b-col', {
            attrs: {
              "md": ['Other'].includes(val.destination) ? '4' : '2'
            }
          }, [_c('b-form-group', {
            attrs: {
              "label": "Destination",
              "label-for": "destination"
            }
          }, [_c('div', {
            staticClass: "d-flex"
          }, [_c('v-select', {
            staticClass: "mr-2",
            staticStyle: {
              "background-color": "#ffffff",
              "width": "200px"
            },
            attrs: {
              "label": "text",
              "options": _vm.positionListTextPOD,
              "reduce": function reduce(positionListTextPOD) {
                return positionListTextPOD.value;
              },
              "placeholder": "Select...",
              "disabled": (_vm$$route$query110 = _vm.$route.query) === null || _vm$$route$query110 === void 0 ? void 0 : _vm$$route$query110.preview
            },
            model: {
              value: val.destination,
              callback: function callback($$v) {
                _vm.$set(val, "destination", $$v);
              },
              expression: "val.destination"
            }
          }), ['Other'].includes(val.destination) ? _c('b-form-input', {
            staticStyle: {
              "background-color": "#ffffff",
              "width": "200px"
            },
            attrs: {
              "type": "text",
              "placeholder": "Other destination...",
              "disabled": (_vm$$route$query111 = _vm.$route.query) === null || _vm$$route$query111 === void 0 ? void 0 : _vm$$route$query111.preview
            },
            model: {
              value: val.destinationOther,
              callback: function callback($$v) {
                _vm.$set(val, "destinationOther", $$v);
              },
              expression: "val.destinationOther"
            }
          }) : _vm._e()], 1)])], 1), _c('b-col', {
            attrs: {
              "md": "2"
            }
          }, [_c('b-form-group', {
            attrs: {
              "label": "Arrival Shelter",
              "label-for": "arrival"
            }
          }, [_c('date-picker', {
            staticClass: "custom-date-picker",
            attrs: {
              "value-type": "DD-MM-YYYY HH:mm",
              "type": "datetime",
              "placeholder": "Select date",
              "format": "DD-MM-YYYY HH:mm",
              "disabled": (_vm$$route$query112 = _vm.$route.query) === null || _vm$$route$query112 === void 0 ? void 0 : _vm$$route$query112.preview
            },
            model: {
              value: val.arrivalShelter,
              callback: function callback($$v) {
                _vm.$set(val, "arrivalShelter", $$v);
              },
              expression: "val.arrivalShelter"
            }
          })], 1)], 1), _c('b-col', {
            attrs: {
              "md": "2"
            }
          }, [_c('b-form-group', {
            attrs: {
              "label": "Drop Anchor Shelter",
              "label-for": "arrival"
            }
          }, [_c('date-picker', {
            staticClass: "custom-date-picker",
            attrs: {
              "value-type": "DD-MM-YYYY HH:mm",
              "type": "datetime",
              "placeholder": "Select date",
              "format": "DD-MM-YYYY HH:mm",
              "disabled": (_vm$$route$query113 = _vm.$route.query) === null || _vm$$route$query113 === void 0 ? void 0 : _vm$$route$query113.preview
            },
            model: {
              value: val.dropAnchorShelter,
              callback: function callback($$v) {
                _vm.$set(val, "dropAnchorShelter", $$v);
              },
              expression: "val.dropAnchorShelter"
            }
          })], 1)], 1), _c('b-col', {
            attrs: {
              "md": "2"
            }
          }, [_c('b-form-group', {
            attrs: {
              "label": "Full Aways Shelter",
              "label-for": "fullaways"
            }
          }, [_c('date-picker', {
            staticClass: "custom-date-picker",
            attrs: {
              "value-type": "DD-MM-YYYY HH:mm",
              "type": "datetime",
              "placeholder": "Select date",
              "format": "DD-MM-YYYY HH:mm",
              "disabled": (_vm$$route$query114 = _vm.$route.query) === null || _vm$$route$query114 === void 0 ? void 0 : _vm$$route$query114.preview
            },
            model: {
              value: val.fullAwayShelter,
              callback: function callback($$v) {
                _vm.$set(val, "fullAwayShelter", $$v);
              },
              expression: "val.fullAwayShelter"
            }
          })], 1)], 1), _c('b-col', {
            attrs: {
              "md": "4"
            }
          }, [_c('b-form-group', {
            attrs: {
              "label": "Remarks",
              "label-for": "arrival"
            }
          }, [_c('b-form-textarea', {
            staticStyle: {
              "background-color": "#ffffff"
            },
            attrs: {
              "name": "remarks",
              "placeholder": "Type Text",
              "disabled": (_vm$$route$query115 = _vm.$route.query) === null || _vm$$route$query115 === void 0 ? void 0 : _vm$$route$query115.preview
            },
            model: {
              value: val.remarks,
              callback: function callback($$v) {
                _vm.$set(val, "remarks", $$v);
              },
              expression: "val.remarks"
            }
          })], 1)], 1), index !== 0 ? _c('b-col', {
            attrs: {
              "md": "1"
            }
          }, [_c('div', {
            staticClass: "d-flex align-items-center w-auto h-100 mt-1"
          }, [_c('i', {
            staticClass: "fa fa-trash text-danger text-xl",
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.formOperationalActivity.shelter.splice(index, 1);
              }
            }
          })])]) : _vm._e(), _c('b-col', {
            attrs: {
              "md": "12"
            }
          }, [_c('div', {
            staticClass: "d-flex w-100 border mb-2"
          })])], 1);
        })], 2)], 1)], 1) : _vm._e()], 1) : _vm._e(), _c('b-col', {
          attrs: {
            "md": "8"
          }
        }, [_c('hr')]), _vm.nextStep && !((_vm$$route$query116 = _vm.$route.query) !== null && _vm$$route$query116 !== void 0 && _vm$$route$query116.preview) ? _c('b-col', {
          staticClass: "text-center mt-3",
          attrs: {
            "md": "8"
          }
        }, [_c('div', {
          staticClass: "d-flex w-100 align-items-center"
        }, [_c('b-button', {
          staticClass: "w-50",
          attrs: {
            "type": "submit",
            "variant": "primary",
            "block": "",
            "disabled": _vm.loadingSubmit
          },
          on: {
            "click": function click($event) {
              return _vm.saveActivity();
            }
          }
        }, [_vm.loadingSubmit ? _c('b-spinner', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }) : _c('i', {
          staticClass: "fa fa-save"
        }), _vm._v(" " + _vm._s(_vm.loadingSubmit ? 'Submitting...' : 'Submit & Save Operational Data') + " ")], 1), !_vm.isEdit ? _c('b-button', {
          staticClass: "iq-bg-danger ml-3 w-50",
          attrs: {
            "variant": "none",
            "block": "",
            "disabled": _vm.loadingSubmit
          },
          on: {
            "click": _vm.resetForm
          }
        }, [_c('i', {
          staticClass: "fa fa-close"
        }), _vm._v(" Reset Form Operational Data")]) : _vm._e(), _vm.isEdit ? _c('b-button', {
          staticClass: "iq-bg-danger ml-3 w-50",
          attrs: {
            "variant": "none",
            "disabled": _vm.loadingSubmit
          },
          on: {
            "click": function click($event) {
              return _vm.cancelEdit();
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-close"
        }), _vm._v(" Cancel Edit Operational Data")]) : _vm._e()], 1)]) : _vm._e()] : _vm._e(), _vm.loadingOperational ? [_c('LoadingOverlayFullscreen', {
          attrs: {
            "visible": _vm.loadingOperational,
            "text": 'Loading data...'
          }
        })] : _vm._e()], 2)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }